export enum PermissionEnum {
  ADMIN_APPOINTMENT_TYPE_CREATE = 'ADMIN_APPOINTMENT_TYPE_CREATE',
  ADMIN_APPOINTMENT_TYPE_LIST = 'ADMIN_APPOINTMENT_TYPE_LIST',
  ADMIN_APPOINTMENT_TYPE_SHOW = 'ADMIN_APPOINTMENT_TYPE_SHOW',
  ADMIN_APPOINTMENT_TYPE_UPDATE = 'ADMIN_APPOINTMENT_TYPE_UPDATE',
  ADMIN_APPOINTMENT_TYPE_DELETE = 'ADMIN_APPOINTMENT_TYPE_DELETE',
  ADMIN_BANK_CREATE = 'ADMIN_BANK_CREATE',
  ADMIN_BANK_LIST = 'ADMIN_BANK_LIST',
  ADMIN_BANK_SHOW = 'ADMIN_BANK_SHOW',
  ADMIN_BANK_UPDATE = 'ADMIN_BANK_UPDATE',
  ADMIN_BANK_DELETE = 'ADMIN_BANK_DELETE',
  ADMIN_BOOKING_HOLIDAY_CREATE = 'ADMIN_BOOKING_HOLIDAY_CREATE',
  ADMIN_BOOKING_HOLIDAY_LIST = 'ADMIN_BOOKING_HOLIDAY_LIST',
  ADMIN_BOOKING_HOLIDAY_SHOW = 'ADMIN_BOOKING_HOLIDAY_SHOW',
  ADMIN_BOOKING_HOLIDAY_UPDATE = 'ADMIN_BOOKING_HOLIDAY_UPDATE',
  ADMIN_BOOKING_HOLIDAY_CANCEL = 'ADMIN_BOOKING_HOLIDAY_CANCEL',
  ADMIN_CASH_DEPOSIT_CREATE = 'ADMIN_CASH_DEPOSIT_CREATE',
  ADMIN_CASH_DEPOSIT_UPLOAD = 'ADMIN_CASH_DEPOSIT_UPLOAD',
  ADMIN_CASH_DEPOSIT_LIST = 'ADMIN_CASH_DEPOSIT_LIST',
  ADMIN_CASH_DEPOSIT_SHOW = 'ADMIN_CASH_DEPOSIT_SHOW',
  ADMIN_CASH_DEPOSIT_DOWNLOAD = 'ADMIN_CASH_DEPOSIT_DOWNLOAD',
  ADMIN_CLIENT_CORPORATE_CREATE = 'ADMIN_CLIENT_CORPORATE_CREATE',
  ADMIN_CLIENT_CORPORATE_LIST = 'ADMIN_CLIENT_CORPORATE_LIST',
  ADMIN_CLIENT_CORPORATE_SHOW = 'ADMIN_CLIENT_CORPORATE_SHOW',
  ADMIN_CLIENT_CORPORATE_UPDATE = 'ADMIN_CLIENT_CORPORATE_UPDATE',
  ADMIN_CLIENT_CORPORATE_DELETE = 'ADMIN_CLIENT_CORPORATE_DELETE',
  ADMIN_CLINIC_CREATE = 'ADMIN_CLINIC_CREATE',
  ADMIN_CLINIC_UPLOAD_STAMP = 'ADMIN_CLINIC_UPLOAD_STAMP',
  ADMIN_CLINIC_LIST = 'ADMIN_CLINIC_LIST',
  ADMIN_CLINIC_SHOW = 'ADMIN_CLINIC_SHOW',
  ADMIN_CLINIC_UPDATE = 'ADMIN_CLINIC_UPDATE',
  ADMIN_CLINIC_OPTION_FOR_ASSIGN_USER_FORM = 'ADMIN_CLINIC_OPTION_FOR_ASSIGN_USER_FORM',
  ADMIN_CLINIC_OPTION_FOR_DOCTOR_FILTER = 'ADMIN_CLINIC_OPTION_FOR_DOCTOR_FILTER',
  ADMIN_CLINIC_OPTION_FOR_NURSE_FILTER = 'ADMIN_CLINIC_OPTION_FOR_NURSE_FILTER',
  ADMIN_CLINIC_OPTION_FOR_PHARMACIST_FILTER = 'ADMIN_CLINIC_OPTION_FOR_PHARMACIST_FILTER',
  ADMIN_CLINIC_OPTION_FOR_PARENT_CLINIC = 'ADMIN_CLINIC_OPTION_FOR_PARENT_CLINIC',
  ADMIN_CLINIC_OPTION_FOR_USER_FILTER = 'ADMIN_CLINIC_OPTION_FOR_USER_FILTER',
  ADMIN_CLINIC_OPTION_FOR_BANK_FORM = 'ADMIN_CLINIC_OPTION_FOR_BANK_FORM',
  ADMIN_CLINIC_OPTION_FOR_PRODUCT_PROMOTION_FORM = 'ADMIN_CLINIC_OPTION_FOR_PRODUCT_PROMOTION_FORM',
  ADMIN_CLINIC_OPTION_FOR_PRODUCT_BUNDLING_FORM = 'ADMIN_CLINIC_OPTION_FOR_PRODUCT_BUNDLING_FORM',
  ADMIN_CLINIC_TYPE_OPTION_FOR_CLINIC_FILTER = 'ADMIN_CLINIC_TYPE_OPTION_FOR_CLINIC_FILTER',
  ADMIN_CLINIC_TYPE_OPTION_FOR_CLINIC_FORM = 'ADMIN_CLINIC_TYPE_OPTION_FOR_CLINIC_FORM',
  ADMIN_CLINIC_USER_CREATE = 'ADMIN_CLINIC_USER_CREATE',
  ADMIN_CLINIC_USER_DELETE = 'ADMIN_CLINIC_USER_DELETE',
  ADMIN_CLINIC_WHITELIST_IP_CREATE = 'ADMIN_CLINIC_WHITELIST_IP_CREATE',
  ADMIN_CLINIC_WHITELIST_IP_LIST = 'ADMIN_CLINIC_WHITELIST_IP_LIST',
  ADMIN_CLINIC_WHITELIST_IP_DELETE = 'ADMIN_CLINIC_WHITELIST_IP_DELETE',
  ADMIN_COMPANY_CREATE = 'ADMIN_COMPANY_CREATE',
  ADMIN_COMPANY_LIST = 'ADMIN_COMPANY_LIST',
  ADMIN_COMPANY_SHOW = 'ADMIN_COMPANY_SHOW',
  ADMIN_COMPANY_UPDATE = 'ADMIN_COMPANY_UPDATE',
  ADMIN_COMPANY_OPTION = 'ADMIN_COMPANY_OPTION',
  ADMIN_COMPANY_OPTION_FOR_CLINIC_FILTER = 'ADMIN_COMPANY_OPTION_FOR_CLINIC_FILTER',
  ADMIN_COMPANY_OPTION_FOR_CLINIC_FORM = 'ADMIN_COMPANY_OPTION_FOR_CLINIC_FORM',
  ADMIN_COMPANY_OPTION_FOR_REPORT_NET_PROMOTER_SCORE_FORM = 'ADMIN_COMPANY_OPTION_FOR_REPORT_NET_PROMOTER_SCORE_FORM',
  ADMIN_COMPANY_OPTION_FOR_REPORT_SALES_FORM = 'ADMIN_COMPANY_OPTION_FOR_REPORT_SALES_FORM',
  ADMIN_COMPANY_OPTION_FOR_REPORT_SERVICE_AND_PERFORMANCE_FORM = 'ADMIN_COMPANY_OPTION_FOR_REPORT_SERVICE_AND_PERFORMANCE_FORM',
  ADMIN_COMPANY_OPTION_FOR_USER_FORM = 'ADMIN_COMPANY_OPTION_FOR_USER_FORM',
  ADMIN_COMPANY_OPTION_FOR_BANK_FORM = 'ADMIN_COMPANY_OPTION_FOR_BANK_FORM',
  ADMIN_DEVELOPER_TOOLS = 'ADMIN_DEVELOPER_TOOLS',
  ADMIN_DOCTOR_CREATE = 'ADMIN_DOCTOR_CREATE',
  ADMIN_DOCTOR_UPLOAD_AVATAR = 'ADMIN_DOCTOR_UPLOAD_AVATAR',
  ADMIN_DOCTOR_LIST = 'ADMIN_DOCTOR_LIST',
  ADMIN_DOCTOR_SHOW = 'ADMIN_DOCTOR_SHOW',
  ADMIN_DOCTOR_UPDATE = 'ADMIN_DOCTOR_UPDATE',
  ADMIN_DOCTOR_OPTION = 'ADMIN_DOCTOR_OPTION',
  ADMIN_DOCTOR_QUALIFICATION_CREATE = 'ADMIN_DOCTOR_QUALIFICATION_CREATE',
  ADMIN_DOCTOR_QUALIFICATION_UPDATE = 'ADMIN_DOCTOR_QUALIFICATION_UPDATE',
  ADMIN_DOCTOR_QUALIFICATION_DELETE = 'ADMIN_DOCTOR_QUALIFICATION_DELETE',
  ADMIN_EXAMINATION_CREATE = 'ADMIN_EXAMINATION_CREATE',
  ADMIN_EXAMINATION_LIST = 'ADMIN_EXAMINATION_LIST',
  ADMIN_EXAMINATION_SHOW = 'ADMIN_EXAMINATION_SHOW',
  ADMIN_EXAMINATION_UPDATE = 'ADMIN_EXAMINATION_UPDATE',
  ADMIN_EXAMINATION_DELETE = 'ADMIN_EXAMINATION_DELETE',
  ADMIN_EXAMINATION_OPTION = 'ADMIN_EXAMINATION_OPTION',
  ADMIN_EXAMINATION_CATEGORY_CREATE = 'ADMIN_EXAMINATION_CATEGORY_CREATE',
  ADMIN_EXAMINATION_CATEGORY_LIST = 'ADMIN_EXAMINATION_CATEGORY_LIST',
  ADMIN_EXAMINATION_CATEGORY_SHOW = 'ADMIN_EXAMINATION_CATEGORY_SHOW',
  ADMIN_EXAMINATION_CATEGORY_UPDATE = 'ADMIN_EXAMINATION_CATEGORY_UPDATE',
  ADMIN_EXAMINATION_CATEGORY_DELETE = 'ADMIN_EXAMINATION_CATEGORY_DELETE',
  ADMIN_EXAMINATION_CATEGORY_OPTION = 'ADMIN_EXAMINATION_CATEGORY_OPTION',
  ADMIN_EXAMINATION_ITEM_CREATE = 'ADMIN_EXAMINATION_ITEM_CREATE',
  ADMIN_EXAMINATION_ITEM_UPDATE = 'ADMIN_EXAMINATION_ITEM_UPDATE',
  ADMIN_EXAMINATION_ITEM_DELETE = 'ADMIN_EXAMINATION_ITEM_DELETE',
  ADMIN_GLOBAL_SETTING_LIST = 'ADMIN_GLOBAL_SETTING_LIST',
  ADMIN_GLOBAL_SETTING_UPDATE = 'ADMIN_GLOBAL_SETTING_UPDATE',
  ADMIN_ICD_10_LIST = 'ADMIN_ICD_10_LIST',
  ADMIN_ICD_10_TREE = 'ADMIN_ICD_10_TREE',
  ADMIN_ICD_10_TRENDING_LIST = 'ADMIN_ICD_10_TRENDING_LIST',
  ADMIN_ICD_10_TRENDING_CREATE = 'ADMIN_ICD_10_TRENDING_CREATE',
  ADMIN_ICD_10_TRENDING_MOVE = 'ADMIN_ICD_10_TRENDING_MOVE',
  ADMIN_ICD_10_TRENDING_DELETE = 'ADMIN_ICD_10_TRENDING_DELETE',
  ADMIN_INJECTION_CREATE = 'ADMIN_INJECTION_CREATE',
  ADMIN_INJECTION_LIST = 'ADMIN_INJECTION_LIST',
  ADMIN_INJECTION_SHOW = 'ADMIN_INJECTION_SHOW',
  ADMIN_INJECTION_UPDATE = 'ADMIN_INJECTION_UPDATE',
  ADMIN_INJECTION_DELETE = 'ADMIN_INJECTION_DELETE',
  ADMIN_INJECTION_ATTENTION_CREATE = 'ADMIN_INJECTION_ATTENTION_CREATE',
  ADMIN_INJECTION_ATTENTION_DELETE = 'ADMIN_INJECTION_ATTENTION_DELETE',
  ADMIN_INJECTION_CATEGORY_CREATE = 'ADMIN_INJECTION_CATEGORY_CREATE',
  ADMIN_INJECTION_CATEGORY_DELETE = 'ADMIN_INJECTION_CATEGORY_DELETE',
  ADMIN_INJECTION_INSTRUCTION_CREATE = 'ADMIN_INJECTION_INSTRUCTION_CREATE',
  ADMIN_INJECTION_INSTRUCTION_DELETE = 'ADMIN_INJECTION_INSTRUCTION_DELETE',
  ADMIN_INJECTION_UNIT_CREATE = 'ADMIN_INJECTION_UNIT_CREATE',
  ADMIN_INJECTION_UNIT_UPDATE = 'ADMIN_INJECTION_UNIT_UPDATE',
  ADMIN_INJECTION_UNIT_DELETE = 'ADMIN_INJECTION_UNIT_DELETE',
  ADMIN_INSURANCE_CREATE = 'ADMIN_INSURANCE_CREATE',
  ADMIN_INSURANCE_LIST = 'ADMIN_INSURANCE_LIST',
  ADMIN_INSURANCE_SHOW = 'ADMIN_INSURANCE_SHOW',
  ADMIN_INSURANCE_UPDATE = 'ADMIN_INSURANCE_UPDATE',
  ADMIN_INSURANCE_DELETE = 'ADMIN_INSURANCE_DELETE',
  ADMIN_INSURANCE_OPTION = 'ADMIN_INSURANCE_OPTION',
  ADMIN_INSURANCE_PAYOR_CREATE = 'ADMIN_INSURANCE_PAYOR_CREATE',
  ADMIN_INSURANCE_PAYOR_LIST = 'ADMIN_INSURANCE_PAYOR_LIST',
  ADMIN_INSURANCE_PAYOR_SHOW = 'ADMIN_INSURANCE_PAYOR_SHOW',
  ADMIN_INSURANCE_PAYOR_UPDATE = 'ADMIN_INSURANCE_PAYOR_UPDATE',
  ADMIN_INSURANCE_PAYOR_DELETE = 'ADMIN_INSURANCE_PAYOR_DELETE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_CREATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_CREATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_LIST = 'ADMIN_MEDICAL_RECORD_TEMPLATE_LIST',
  ADMIN_MEDICAL_RECORD_TEMPLATE_SHOW = 'ADMIN_MEDICAL_RECORD_TEMPLATE_SHOW',
  ADMIN_MEDICAL_RECORD_TEMPLATE_UPDATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_UPDATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_DELETE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_DELETE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_DIAGNOSE_CREATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_DIAGNOSE_CREATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_DIAGNOSE_UPDATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_DIAGNOSE_UPDATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_DIAGNOSE_DELETE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_DIAGNOSE_DELETE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_EXAMINATION_CREATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_EXAMINATION_CREATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_EXAMINATION_UPDATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_EXAMINATION_UPDATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_EXAMINATION_DELETE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_EXAMINATION_DELETE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_CREATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_CREATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_UPDATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_UPDATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_DELETE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_DELETE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_CREATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_CREATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_UPDATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_UPDATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_DELETE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_DELETE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_TREATMENT_CREATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_TREATMENT_CREATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_TREATMENT_UPDATE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_TREATMENT_UPDATE',
  ADMIN_MEDICAL_RECORD_TEMPLATE_TREATMENT_DELETE = 'ADMIN_MEDICAL_RECORD_TEMPLATE_TREATMENT_DELETE',
  ADMIN_MEDICAL_TOOL_CREATE = 'ADMIN_MEDICAL_TOOL_CREATE',
  ADMIN_MEDICAL_TOOL_LIST = 'ADMIN_MEDICAL_TOOL_LIST',
  ADMIN_MEDICAL_TOOL_SHOW = 'ADMIN_MEDICAL_TOOL_SHOW',
  ADMIN_MEDICAL_TOOL_UPDATE = 'ADMIN_MEDICAL_TOOL_UPDATE',
  ADMIN_MEDICAL_TOOL_DELETE = 'ADMIN_MEDICAL_TOOL_DELETE',
  ADMIN_MEDICAL_TOOL_CREATE_PRODUCT_UNIT = 'ADMIN_MEDICAL_TOOL_CREATE_PRODUCT_UNIT',
  ADMIN_MEDICAL_TOOL_UPDATE_PRODUCT_UNIT = 'ADMIN_MEDICAL_TOOL_UPDATE_PRODUCT_UNIT',
  ADMIN_MEDICAL_TOOL_DELETE_PRODUCT_UNIT = 'ADMIN_MEDICAL_TOOL_DELETE_PRODUCT_UNIT',
  ADMIN_MEDICAL_TOOL_OPTION = 'ADMIN_MEDICAL_TOOL_OPTION',
  ADMIN_MEDICINAL_ATTENTION_CREATE = 'ADMIN_MEDICINAL_ATTENTION_CREATE',
  ADMIN_MEDICINAL_ATTENTION_LIST = 'ADMIN_MEDICINAL_ATTENTION_LIST',
  ADMIN_MEDICINAL_ATTENTION_UPDATE = 'ADMIN_MEDICINAL_ATTENTION_UPDATE',
  ADMIN_MEDICINAL_ATTENTION_DELETE = 'ADMIN_MEDICINAL_ATTENTION_DELETE',
  ADMIN_MEDICINAL_ATTENTION_OPTION_FOR_AMP_FORM = 'ADMIN_MEDICINAL_ATTENTION_OPTION_FOR_AMP_FORM',
  ADMIN_MEDICINAL_CATEGORY_CREATE = 'ADMIN_MEDICINAL_CATEGORY_CREATE',
  ADMIN_MEDICINAL_CATEGORY_LIST = 'ADMIN_MEDICINAL_CATEGORY_LIST',
  ADMIN_MEDICINAL_CATEGORY_UPDATE = 'ADMIN_MEDICINAL_CATEGORY_UPDATE',
  ADMIN_MEDICINAL_CATEGORY_DELETE = 'ADMIN_MEDICINAL_CATEGORY_DELETE',
  ADMIN_MEDICINAL_CATEGORY_OPTION_FOR_AMP_FORM = 'ADMIN_MEDICINAL_CATEGORY_OPTION_FOR_AMP_FORM',
  ADMIN_MEDICINAL_CLASSIFICATION_CREATE = 'ADMIN_MEDICINAL_CLASSIFICATION_CREATE',
  ADMIN_MEDICINAL_CLASSIFICATION_UPDATE = 'ADMIN_MEDICINAL_CLASSIFICATION_UPDATE',
  ADMIN_MEDICINAL_CLASSIFICATION_LIST = 'ADMIN_MEDICINAL_CLASSIFICATION_LIST',
  ADMIN_MEDICINAL_CLASSIFICATION_DELETE = 'ADMIN_MEDICINAL_CLASSIFICATION_DELETE',
  ADMIN_MEDICINAL_CLASSIFICATION_OPTION = 'ADMIN_MEDICINAL_CLASSIFICATION_OPTION',
  ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_CREATE = 'ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_CREATE',
  ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_LIST = 'ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_LIST',
  ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_UPDATE = 'ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_UPDATE',
  ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_DELETE = 'ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_DELETE',
  ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_OPTION = 'ADMIN_MEDICINAL_CONTROLLED_DRUG_CLASSIFICATION_OPTION',
  ADMIN_MEDICINAL_FORM_CREATE = 'ADMIN_MEDICINAL_FORM_CREATE',
  ADMIN_MEDICINAL_FORM_LIST = 'ADMIN_MEDICINAL_FORM_LIST',
  ADMIN_MEDICINAL_FORM_UPDATE = 'ADMIN_MEDICINAL_FORM_UPDATE',
  ADMIN_MEDICINAL_FORM_DELETE = 'ADMIN_MEDICINAL_FORM_DELETE',
  ADMIN_MEDICINAL_FORM_OPTION = 'ADMIN_MEDICINAL_FORM_OPTION',
  ADMIN_MEDICINAL_INSTRUCTION_CREATE = 'ADMIN_MEDICINAL_INSTRUCTION_CREATE',
  ADMIN_MEDICINAL_INSTRUCTION_UPDATE = 'ADMIN_MEDICINAL_INSTRUCTION_UPDATE',
  ADMIN_MEDICINAL_INSTRUCTION_LIST = 'ADMIN_MEDICINAL_INSTRUCTION_LIST',
  ADMIN_MEDICINAL_INSTRUCTION_DELETE = 'ADMIN_MEDICINAL_INSTRUCTION_DELETE',
  ADMIN_MEDICINAL_INSTRUCTION_OPTION_FOR_AMP_FORM = 'ADMIN_MEDICINAL_INSTRUCTION_OPTION_FOR_AMP_FORM',
  ADMIN_MEDICINAL_ROUTE_CREATE = 'ADMIN_MEDICINAL_ROUTE_CREATE',
  ADMIN_MEDICINAL_ROUTE_LIST = 'ADMIN_MEDICINAL_ROUTE_LIST',
  ADMIN_MEDICINAL_ROUTE_UPDATE = 'ADMIN_MEDICINAL_ROUTE_UPDATE',
  ADMIN_MEDICINAL_ROUTE_DELETE = 'ADMIN_MEDICINAL_ROUTE_DELETE',
  ADMIN_MEDICINAL_ROUTE_OPTION = 'ADMIN_MEDICINAL_ROUTE_OPTION',
  ADMIN_MEDICINE_CREATE = 'ADMIN_MEDICINE_CREATE',
  ADMIN_MEDICINE_LIST = 'ADMIN_MEDICINE_LIST',
  ADMIN_MEDICINE_SHOW = 'ADMIN_MEDICINE_SHOW',
  ADMIN_MEDICINE_UPDATE = 'ADMIN_MEDICINE_UPDATE',
  ADMIN_MEDICINE_DELETE = 'ADMIN_MEDICINE_DELETE',
  ADMIN_MEDICINE_ATTENTION_CREATE = 'ADMIN_MEDICINE_ATTENTION_CREATE',
  ADMIN_MEDICINE_ATTENTION_DELETE = 'ADMIN_MEDICINE_ATTENTION_DELETE',
  ADMIN_MEDICINE_CATEGORY_CREATE = 'ADMIN_MEDICINE_CATEGORY_CREATE',
  ADMIN_MEDICINE_CATEGORY_DELETE = 'ADMIN_MEDICINE_CATEGORY_DELETE',
  ADMIN_MEDICINE_INSTRUCTION_CREATE = 'ADMIN_MEDICINE_INSTRUCTION_CREATE',
  ADMIN_MEDICINE_INSTRUCTION_DELETE = 'ADMIN_MEDICINE_INSTRUCTION_DELETE',
  ADMIN_MEDICINE_UNIT_CREATE = 'ADMIN_MEDICINE_UNIT_CREATE',
  ADMIN_MEDICINE_UNIT_UPDATE = 'ADMIN_MEDICINE_UNIT_UPDATE',
  ADMIN_MEDICINE_UNIT_DELETE = 'ADMIN_MEDICINE_UNIT_DELETE',
  ADMIN_NURSE_CREATE = 'ADMIN_NURSE_CREATE',
  ADMIN_NURSE_LIST = 'ADMIN_NURSE_LIST',
  ADMIN_NURSE_SHOW = 'ADMIN_NURSE_SHOW',
  ADMIN_NURSE_UPDATE = 'ADMIN_NURSE_UPDATE',
  ADMIN_NURSE_QUALIFICATION_CREATE = 'ADMIN_NURSE_QUALIFICATION_CREATE',
  ADMIN_NURSE_QUALIFICATION_UPDATE = 'ADMIN_NURSE_QUALIFICATION_UPDATE',
  ADMIN_NURSE_QUALIFICATION_DELETE = 'ADMIN_NURSE_QUALIFICATION_DELETE',
  ADMIN_PHARMACIST_CREATE = 'ADMIN_PHARMACIST_CREATE',
  ADMIN_PHARMACIST_LIST = 'ADMIN_PHARMACIST_LIST',
  ADMIN_PHARMACIST_SHOW = 'ADMIN_PHARMACIST_SHOW',
  ADMIN_PHARMACIST_UPDATE = 'ADMIN_PHARMACIST_UPDATE',
  ADMIN_PHARMACIST_OPTION_FOR_CREATE_CLINIC_FORM = 'ADMIN_PHARMACIST_OPTION_FOR_CREATE_CLINIC_FORM',
  ADMIN_PHARMACIST_OPTION_FOR_UPDATE_CLINIC_FORM = 'ADMIN_PHARMACIST_OPTION_FOR_UPDATE_CLINIC_FORM',
  ADMIN_PHARMACIST_QUALIFICATION_CREATE = 'ADMIN_PHARMACIST_QUALIFICATION_CREATE',
  ADMIN_PHARMACIST_QUALIFICATION_UPDATE = 'ADMIN_PHARMACIST_QUALIFICATION_UPDATE',
  ADMIN_PHARMACIST_QUALIFICATION_DELETE = 'ADMIN_PHARMACIST_QUALIFICATION_DELETE',
  ADMIN_POWERBI_SHOW = 'ADMIN_POWERBI_SHOW',
  ADMIN_PRODUCT_OPTION = 'ADMIN_PRODUCT_OPTION',
  ADMIN_PRODUCT_OPTION_FOR_EXAMINATION_ITEM = 'ADMIN_PRODUCT_OPTION_FOR_EXAMINATION_ITEM',
  ADMIN_PRODUCT_OPTION_FOR_RETAIL_PRODUCT = 'ADMIN_PRODUCT_OPTION_FOR_RETAIL_PRODUCT',
  ADMIN_PRODUCT_OPTION_FOR_TREATMENT_ITEM = 'ADMIN_PRODUCT_OPTION_FOR_TREATMENT_ITEM',
  ADMIN_PRODUCT_OPTION_FOR_PRODUCT_PROMOTION = 'ADMIN_PRODUCT_OPTION_FOR_PRODUCT_PROMOTION',
  ADMIN_PRODUCT_OPTION_FOR_PRODUCT_BUNDLING_ITEM = 'ADMIN_PRODUCT_OPTION_FOR_PRODUCT_BUNDLING_ITEM',
  ADMIN_PRODUCT_BUNDLING_CREATE = 'ADMIN_PRODUCT_BUNDLING_CREATE',
  ADMIN_PRODUCT_BUNDLING_LIST = 'ADMIN_PRODUCT_BUNDLING_LIST',
  ADMIN_PRODUCT_BUNDLING_SHOW = 'ADMIN_PRODUCT_BUNDLING_SHOW',
  ADMIN_PRODUCT_BUNDLING_UPDATE = 'ADMIN_PRODUCT_BUNDLING_UPDATE',
  ADMIN_PRODUCT_BUNDLING_UPDATE_ENDED_AT = 'ADMIN_PRODUCT_BUNDLING_UPDATE_ENDED_AT',
  ADMIN_PRODUCT_BUNDLING_DELETE = 'ADMIN_PRODUCT_BUNDLING_DELETE',
  ADMIN_PRODUCT_BUNDLING_CLINIC_CREATE = 'ADMIN_PRODUCT_BUNDLING_CLINIC_CREATE',
  ADMIN_PRODUCT_BUNDLING_CLINIC_DELETE = 'ADMIN_PRODUCT_BUNDLING_CLINIC_DELETE',
  ADMIN_PRODUCT_BUNDLING_ITEM_CREATE = 'ADMIN_PRODUCT_BUNDLING_ITEM_CREATE',
  ADMIN_PRODUCT_BUNDLING_ITEM_DELETE = 'ADMIN_PRODUCT_BUNDLING_ITEM_DELETE',
  ADMIN_PRODUCT_PROMOTION_CREATE = 'ADMIN_PRODUCT_PROMOTION_CREATE',
  ADMIN_PRODUCT_PROMOTION_LIST = 'ADMIN_PRODUCT_PROMOTION_LIST',
  ADMIN_PRODUCT_PROMOTION_SHOW = 'ADMIN_PRODUCT_PROMOTION_SHOW',
  ADMIN_PRODUCT_PROMOTION_UPDATE = 'ADMIN_PRODUCT_PROMOTION_UPDATE',
  ADMIN_PRODUCT_PROMOTION_UPDATE_ENDED_AT = 'ADMIN_PRODUCT_PROMOTION_UPDATE_ENDED_AT',
  ADMIN_PRODUCT_PROMOTION_DELETE = 'ADMIN_PRODUCT_PROMOTION_DELETE',
  ADMIN_PRODUCT_PROMOTION_CLINIC_CREATE = 'ADMIN_PRODUCT_PROMOTION_CLINIC_CREATE',
  ADMIN_PRODUCT_PROMOTION_CLINIC_DELETE = 'ADMIN_PRODUCT_PROMOTION_CLINIC_DELETE',
  ADMIN_PRODUCT_UNIT_OPTION = 'ADMIN_PRODUCT_UNIT_OPTION',
  ADMIN_QUALIFICATION_TYPE_CREATE = 'ADMIN_QUALIFICATION_TYPE_CREATE',
  ADMIN_QUALIFICATION_TYPE_LIST = 'ADMIN_QUALIFICATION_TYPE_LIST',
  ADMIN_QUALIFICATION_TYPE_SHOW = 'ADMIN_QUALIFICATION_TYPE_SHOW',
  ADMIN_QUALIFICATION_TYPE_UPDATE = 'ADMIN_QUALIFICATION_TYPE_UPDATE',
  ADMIN_QUALIFICATION_TYPE_DELETE = 'ADMIN_QUALIFICATION_TYPE_DELETE',
  ADMIN_QUALIFICATION_TYPE_OPTION = 'ADMIN_QUALIFICATION_TYPE_OPTION',
  ADMIN_RADIOGRAPHER_CREATE = 'ADMIN_RADIOGRAPHER_CREATE',
  ADMIN_RADIOGRAPHER_LIST = 'ADMIN_RADIOGRAPHER_LIST',
  ADMIN_RADIOGRAPHER_SHOW = 'ADMIN_RADIOGRAPHER_SHOW',
  ADMIN_RADIOGRAPHER_UPDATE = 'ADMIN_RADIOGRAPHER_UPDATE',
  ADMIN_RETAIL_PRODUCT_CREATE = 'ADMIN_RETAIL_PRODUCT_CREATE',
  ADMIN_RETAIL_PRODUCT_UPLOAD = 'ADMIN_RETAIL_PRODUCT_UPLOAD',
  ADMIN_RETAIL_PRODUCT_LIST = 'ADMIN_RETAIL_PRODUCT_LIST',
  ADMIN_RETAIL_PRODUCT_SHOW = 'ADMIN_RETAIL_PRODUCT_SHOW',
  ADMIN_RETAIL_PRODUCT_UPDATE = 'ADMIN_RETAIL_PRODUCT_UPDATE',
  ADMIN_RETAIL_PRODUCT_DELETE = 'ADMIN_RETAIL_PRODUCT_DELETE',
  ADMIN_RETAIL_PRODUCT_CREATE_PRODUCT_UNIT = 'ADMIN_RETAIL_PRODUCT_CREATE_PRODUCT_UNIT',
  ADMIN_RETAIL_PRODUCT_UPDATE_PRODUCT_UNIT = 'ADMIN_RETAIL_PRODUCT_UPDATE_PRODUCT_UNIT',
  ADMIN_RETAIL_PRODUCT_DELETE_PRODUCT_UNIT = 'ADMIN_RETAIL_PRODUCT_DELETE_PRODUCT_UNIT',
  ADMIN_RETAIL_PRODUCT_CATEGORY_CREATE = 'ADMIN_RETAIL_PRODUCT_CATEGORY_CREATE',
  ADMIN_RETAIL_PRODUCT_CATEGORY_LIST = 'ADMIN_RETAIL_PRODUCT_CATEGORY_LIST',
  ADMIN_RETAIL_PRODUCT_CATEGORY_UPDATE = 'ADMIN_RETAIL_PRODUCT_CATEGORY_UPDATE',
  ADMIN_RETAIL_PRODUCT_CATEGORY_DELETE = 'ADMIN_RETAIL_PRODUCT_CATEGORY_DELETE',
  ADMIN_RETAIL_PRODUCT_CATEGORY_OPTION_FOR_RETAIL_PRODUCT_FORM = 'ADMIN_RETAIL_PRODUCT_CATEGORY_OPTION_FOR_RETAIL_PRODUCT_FORM',
  ADMIN_ROLE_LIST = 'ADMIN_ROLE_LIST',
  ADMIN_ROLE_SHOW = 'ADMIN_ROLE_SHOW',
  ADMIN_ROLE_OPTION = 'ADMIN_ROLE_OPTION',
  ADMIN_ROLE_OPTION_FOR_USER_FILTER = 'ADMIN_ROLE_OPTION_FOR_USER_FILTER',
  ADMIN_ROLE_OPTION_FOR_USER_FORM = 'ADMIN_ROLE_OPTION_FOR_USER_FORM',
  ADMIN_SUPPLIER_CREATE = 'ADMIN_SUPPLIER_CREATE',
  ADMIN_SUPPLIER_FETCH = 'ADMIN_SUPPLIER_FETCH',
  ADMIN_SUPPLIER_GET = 'ADMIN_SUPPLIER_GET',
  ADMIN_SUPPLIER_UPDATE = 'ADMIN_SUPPLIER_UPDATE',
  ADMIN_SUPPLIER_DELETE = 'ADMIN_SUPPLIER_DELETE',
  ADMIN_SUPPLIER_OPTION_FOR_EXAMINATION_FORM = 'ADMIN_SUPPLIER_OPTION_FOR_EXAMINATION_FORM',
  ADMIN_TREATMENT_CREATE = 'ADMIN_TREATMENT_CREATE',
  ADMIN_TREATMENT_LIST = 'ADMIN_TREATMENT_LIST',
  ADMIN_TREATMENT_SHOW = 'ADMIN_TREATMENT_SHOW',
  ADMIN_TREATMENT_UPDATE = 'ADMIN_TREATMENT_UPDATE',
  ADMIN_TREATMENT_DELETE = 'ADMIN_TREATMENT_DELETE',
  ADMIN_TREATMENT_OPTION = 'ADMIN_TREATMENT_OPTION',
  ADMIN_TREATMENT_CATEGORY_CREATE = 'ADMIN_TREATMENT_CATEGORY_CREATE',
  ADMIN_TREATMENT_CATEGORY_LIST = 'ADMIN_TREATMENT_CATEGORY_LIST',
  ADMIN_TREATMENT_CATEGORY_UPDATE = 'ADMIN_TREATMENT_CATEGORY_UPDATE',
  ADMIN_TREATMENT_CATEGORY_DELETE = 'ADMIN_TREATMENT_CATEGORY_DELETE',
  ADMIN_TREATMENT_CATEGORY_OPTION = 'ADMIN_TREATMENT_CATEGORY_OPTION',
  ADMIN_TREATMENT_ITEM_CREATE = 'ADMIN_TREATMENT_ITEM_CREATE',
  ADMIN_TREATMENT_ITEM_UPDATE = 'ADMIN_TREATMENT_ITEM_UPDATE',
  ADMIN_TREATMENT_ITEM_DELETE = 'ADMIN_TREATMENT_ITEM_DELETE',
  ADMIN_UNIT_CREATE = 'ADMIN_UNIT_CREATE',
  ADMIN_UNIT_LIST = 'ADMIN_UNIT_LIST',
  ADMIN_UNIT_UPDATE = 'ADMIN_UNIT_UPDATE',
  ADMIN_UNIT_DELETE = 'ADMIN_UNIT_DELETE',
  ADMIN_UNIT_OPTION_FOR_PRODUCT_FORM = 'ADMIN_UNIT_OPTION_FOR_PRODUCT_FORM',
  ADMIN_USER_CREATE = 'ADMIN_USER_CREATE',
  ADMIN_USER_LIST = 'ADMIN_USER_LIST',
  ADMIN_USER_SHOW = 'ADMIN_USER_SHOW',
  ADMIN_USER_UPDATE = 'ADMIN_USER_UPDATE',
  ADMIN_USER_OPTION_FOR_DOCTOR_FORM = 'ADMIN_USER_OPTION_FOR_DOCTOR_FORM',
  ADMIN_USER_OPTION_FOR_NURSE_FORM = 'ADMIN_USER_OPTION_FOR_NURSE_FORM',
  ADMIN_USER_OPTION_FOR_PHARMACIST_FORM = 'ADMIN_USER_OPTION_FOR_PHARMACIST_FORM',
  ADMIN_USER_OPTION_FOR_RADIOGRAPHER_FORM = 'ADMIN_USER_OPTION_FOR_RADIOGRAPHER_FORM',
  ADMIN_VACCINE_CREATE = 'ADMIN_VACCINE_CREATE',
  ADMIN_VACCINE_LIST = 'ADMIN_VACCINE_LIST',
  ADMIN_VACCINE_SHOW = 'ADMIN_VACCINE_SHOW',
  ADMIN_VACCINE_UPDATE = 'ADMIN_VACCINE_UPDATE',
  ADMIN_VACCINE_DELETE = 'ADMIN_VACCINE_DELETE',
  ADMIN_VACCINE_ATTENTION_CREATE = 'ADMIN_VACCINE_ATTENTION_CREATE',
  ADMIN_VACCINE_ATTENTION_DELETE = 'ADMIN_VACCINE_ATTENTION_DELETE',
  ADMIN_VACCINE_CATEGORY_CREATE = 'ADMIN_VACCINE_CATEGORY_CREATE',
  ADMIN_VACCINE_CATEGORY_DELETE = 'ADMIN_VACCINE_CATEGORY_DELETE',
  ADMIN_VACCINE_INSTRUCTION_CREATE = 'ADMIN_VACCINE_INSTRUCTION_CREATE',
  ADMIN_VACCINE_INSTRUCTION_DELETE = 'ADMIN_VACCINE_INSTRUCTION_DELETE',
  ADMIN_VACCINE_UNIT_CREATE = 'ADMIN_VACCINE_UNIT_CREATE',
  ADMIN_VACCINE_UNIT_UPDATE = 'ADMIN_VACCINE_UNIT_UPDATE',
  ADMIN_VACCINE_UNIT_DELETE = 'ADMIN_VACCINE_UNIT_DELETE',
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_CREATE = 'ADMIN_VIRTUAL_MEDICINAL_PRODUCT_CREATE',
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_LIST = 'ADMIN_VIRTUAL_MEDICINAL_PRODUCT_LIST',
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_SHOW = 'ADMIN_VIRTUAL_MEDICINAL_PRODUCT_SHOW',
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_UPDATE = 'ADMIN_VIRTUAL_MEDICINAL_PRODUCT_UPDATE',
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_DELETE = 'ADMIN_VIRTUAL_MEDICINAL_PRODUCT_DELETE',
  ADMIN_VIRTUAL_MEDICINAL_PRODUCT_OPTION = 'ADMIN_VIRTUAL_MEDICINAL_PRODUCT_OPTION',
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_LIST = 'ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_LIST',
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_SHOW = 'ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_SHOW',
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_CREATE = 'ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_CREATE',
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_UPDATE = 'ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_UPDATE',
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_DELETE = 'ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_DELETE',
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_OPTION = 'ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_OPTION',
  ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_OPTION_FOR_VMP_VTM_FORM = 'ADMIN_VIRTUAL_THERAPEUTIC_MOIETY_OPTION_FOR_VMP_VTM_FORM',
  ADMIN_VMP_CODE_CREATE = 'ADMIN_VMP_CODE_CREATE',
  ADMIN_VMP_CODE_DELETE = 'ADMIN_VMP_CODE_DELETE',
  ADMIN_VMP_VTM_CREATE = 'ADMIN_VMP_VTM_CREATE',
  ADMIN_VMP_VTM_UPDATE = 'ADMIN_VMP_VTM_UPDATE',
  ADMIN_VMP_VTM_DELETE = 'ADMIN_VMP_VTM_DELETE',
  ADMIN_VTM_CODE_CREATE = 'ADMIN_VTM_CODE_CREATE',
  ADMIN_VTM_CODE_DELETE = 'ADMIN_VTM_CODE_DELETE',
  ADMIN_VOUCHER_CODE_CREATE = 'ADMIN_VOUCHER_CODE_CREATE',
  ADMIN_VOUCHER_CODE_LIST = 'ADMIN_VOUCHER_CODE_LIST',
  ADMIN_VOUCHER_CODE_SHOW = 'ADMIN_VOUCHER_CODE_SHOW',
  ADMIN_VOUCHER_CODE_UPDATE = 'ADMIN_VOUCHER_CODE_UPDATE',
  ADMIN_VOUCHER_CODE_DELETE = 'ADMIN_VOUCHER_CODE_DELETE',
  ADMIN_VOUCHER_CODE_REDEEM_LIST = 'ADMIN_VOUCHER_CODE_REDEEM_LIST',
  ADMIN_VOUCHER_CODE_REDEEM_SHOW = 'ADMIN_VOUCHER_CODE_REDEEM_SHOW',
  ADMIN_VOUCHER_GENERATE_RULE_CREATE = 'ADMIN_VOUCHER_GENERATE_RULE_CREATE',
  ADMIN_VOUCHER_GENERATE_RULE_LIST = 'ADMIN_VOUCHER_GENERATE_RULE_LIST',
  ADMIN_VOUCHER_GENERATE_RULE_SHOW = 'ADMIN_VOUCHER_GENERATE_RULE_SHOW',
  ADMIN_VOUCHER_GENERATE_RULE_UPDATE = 'ADMIN_VOUCHER_GENERATE_RULE_UPDATE',
  ADMIN_VOUCHER_GENERATE_RULE_DELETE = 'ADMIN_VOUCHER_GENERATE_RULE_DELETE',
  CASHIER_SALES_INVOICE_LIST = 'CASHIER_SALES_INVOICE_LIST',
  CASHIER_SALES_INVOICE_SHOW = 'CASHIER_SALES_INVOICE_SHOW',
  CLUSTER_MANAGER_CLINIC_GET_CASH_ON_HAND = 'CLUSTER_MANAGER_CLINIC_GET_CASH_ON_HAND',
  CLUSTER_MANAGER_CLINIC_OPTION_FOR_CASHIER_SUMMARY_LIST = 'CLUSTER_MANAGER_CLINIC_OPTION_FOR_CASHIER_SUMMARY_LIST',
  CLUSTER_MANAGER_CLINIC_OPTION_FOR_CASH_DEPOSIT_FORM = 'CLUSTER_MANAGER_CLINIC_OPTION_FOR_CASH_DEPOSIT_FORM',
  CLUSTER_MANAGER_CLINIC_OPTION_FOR_CASH_DEPOSIT_FILTER = 'CLUSTER_MANAGER_CLINIC_OPTION_FOR_CASH_DEPOSIT_FILTER',
  CLUSTER_MANAGER_CASHIER_SUMMARY_LIST = 'CLUSTER_MANAGER_CASHIER_SUMMARY_LIST',
  CLUSTER_MANAGER_CASHIER_SUMMARY_LIST_SUMMARIZED = 'CLUSTER_MANAGER_CASHIER_SUMMARY_LIST_SUMMARIZED',
  CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW = 'CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW',
  CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW_SESSION = 'CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW_SESSION',
  CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW_SALES_INVOICE = 'CLUSTER_MANAGER_CASHIER_SUMMARY_SHOW_SALES_INVOICE',
  CLUSTER_MANAGER_CASHIER_SUMMARY_DOWNLOAD_CSV = 'CLUSTER_MANAGER_CASHIER_SUMMARY_DOWNLOAD_CSV',
  CLINIC_MANAGER_SALES_INVOICE_LIST = 'CLINIC_MANAGER_SALES_INVOICE_LIST',
  CLINIC_MANAGER_SALES_INVOICE_DOWNLOAD = 'CLINIC_MANAGER_SALES_INVOICE_DOWNLOAD',
  DOCTOR_PATIENT_VITAL_CHECK_CREATE = 'DOCTOR_PATIENT_VITAL_CHECK_CREATE',
  DOCTOR_PATIENT_VITAL_CHECK_UPDATE = 'DOCTOR_PATIENT_VITAL_CHECK_UPDATE',
  NURSE_PATIENT_VITAL_CHECK_CREATE = 'NURSE_PATIENT_VITAL_CHECK_CREATE',
  NURSE_PATIENT_VITAL_CHECK_UPDATE = 'NURSE_PATIENT_VITAL_CHECK_UPDATE',
  APPOINTMENT_CREATE = 'APPOINTMENT_CREATE',
  APPOINTMENT_LIST = 'APPOINTMENT_LIST',
  APPOINTMENT_LIST_FOR_APPOINTMENT_FORM_BY_CLINIC_OR_DOCTOR = 'APPOINTMENT_LIST_FOR_APPOINTMENT_FORM_BY_CLINIC_OR_DOCTOR',
  APPOINTMENT_LIST_FOR_APPOINTMENT_FORM_BY_PATIENT = 'APPOINTMENT_LIST_FOR_APPOINTMENT_FORM_BY_PATIENT',
  APPOINTMENT_LIST_FOR_QUEUE_NUMBER_GENERATE_FORM_BY_PATIENT = 'APPOINTMENT_LIST_FOR_QUEUE_NUMBER_GENERATE_FORM_BY_PATIENT',
  APPOINTMENT_SHOW = 'APPOINTMENT_SHOW',
  APPOINTMENT_UPDATE = 'APPOINTMENT_UPDATE',
  APPOINTMENT_UPDATE_REFERRED_DOCTOR = 'APPOINTMENT_UPDATE_REFERRED_DOCTOR',
  APPOINTMENT_APPROVE = 'APPOINTMENT_APPROVE',
  APPOINTMENT_CANCEL = 'APPOINTMENT_CANCEL',
  APPOINTMENT_TYPE_OPTION = 'APPOINTMENT_TYPE_OPTION',
  BANK_OPTION_FOR_CASH_DEPOSIT_FORM = 'BANK_OPTION_FOR_CASH_DEPOSIT_FORM',
  BOOKING_CALENDAR = 'BOOKING_CALENDAR',
  BOOKING_CREATE = 'BOOKING_CREATE',
  BOOKING_CANCEL = 'BOOKING_CANCEL',
  BOOKING_CHANGE_DOCTOR = 'BOOKING_CHANGE_DOCTOR',
  BOOKING_RESCHEDULE = 'BOOKING_RESCHEDULE',
  CASH_DEPOSIT_LIST = 'CASH_DEPOSIT_LIST',
  CASH_DEPOSIT_SHOW = 'CASH_DEPOSIT_SHOW',
  CASH_DEPOSIT_DOWNLOAD = 'CASH_DEPOSIT_DOWNLOAD',
  CASHIER_CREATE = 'CASHIER_CREATE',
  CASHIER_LIST = 'CASHIER_LIST',
  CASHIER_SHOW = 'CASHIER_SHOW',
  CASHIER_UPDATE = 'CASHIER_UPDATE',
  CASHIER_DELETE = 'CASHIER_DELETE',
  CASHIER_OPTION_FOR_START_CASHIER_SESSION_FORM = 'CASHIER_OPTION_FOR_START_CASHIER_SESSION_FORM',
  CASHIER_SESSION_CREATE = 'CASHIER_SESSION_CREATE',
  CASHIER_SESSION_OPEN_DRAWER = 'CASHIER_SESSION_OPEN_DRAWER',
  CASHIER_SESSION_LIST = 'CASHIER_SESSION_LIST',
  CASHIER_SESSION_SHOW = 'CASHIER_SESSION_SHOW',
  CASHIER_SESSION_SHOW_ACTIVE = 'CASHIER_SESSION_SHOW_ACTIVE',
  CASHIER_SESSION_CLOSE = 'CASHIER_SESSION_CLOSE',
  CASHIER_SESSION_UPDATE_MONEY_COUNT = 'CASHIER_SESSION_UPDATE_MONEY_COUNT',
  CASHIER_SESSION_END = 'CASHIER_SESSION_END',
  CASHIER_SUMMARY_CREATE = 'CASHIER_SUMMARY_CREATE',
  CASHIER_SUMMARY_LIST = 'CASHIER_SUMMARY_LIST',
  CASHIER_SUMMARY_LIST_SUMMARIZED = 'CASHIER_SUMMARY_LIST_SUMMARIZED',
  CASHIER_SUMMARY_SHOW = 'CASHIER_SUMMARY_SHOW',
  CASHIER_SUMMARY_SHOW_DAILY_REPORT = 'CASHIER_SUMMARY_SHOW_DAILY_REPORT',
  CASHIER_SUMMARY_SHOW_SESSION = 'CASHIER_SUMMARY_SHOW_SESSION',
  CASHIER_SUMMARY_SHOW_DAILY_REPORT_SESSION = 'CASHIER_SUMMARY_SHOW_DAILY_REPORT_SESSION',
  CASHIER_SUMMARY_SHOW_SALES_INVOICE = 'CASHIER_SUMMARY_SHOW_SALES_INVOICE',
  CASHIER_SUMMARY_SHOW_DAILY_REPORT_SALES_INVOICE = 'CASHIER_SUMMARY_SHOW_DAILY_REPORT_SALES_INVOICE',
  CASHIER_SUMMARY_DOWNLOAD_CSV = 'CASHIER_SUMMARY_DOWNLOAD_CSV',
  CLIENT_CORPORATE_OPTION_FOR_DIAGNOSTIC_ANCILLARY = 'CLIENT_CORPORATE_OPTION_FOR_DIAGNOSTIC_ANCILLARY',
  CLINIC_OPTION_FOR_APPOINTMENT_FORM = 'CLINIC_OPTION_FOR_APPOINTMENT_FORM',
  CLINIC_OPTION_FOR_PRODUCT_TRANSFER_CLINIC_FORM = 'CLINIC_OPTION_FOR_PRODUCT_TRANSFER_CLINIC_FORM',
  CLINIC_OPTION_FOR_DIAGNOSTIC_ANCILLARY_FORM = 'CLINIC_OPTION_FOR_DIAGNOSTIC_ANCILLARY_FORM',
  CLINIC_BOOKING_CLOSED_TIME_CREATE = 'CLINIC_BOOKING_CLOSED_TIME_CREATE',
  CLINIC_BOOKING_CLOSED_TIME_LIST = 'CLINIC_BOOKING_CLOSED_TIME_LIST',
  CLINIC_BOOKING_CLOSED_TIME_SHOW = 'CLINIC_BOOKING_CLOSED_TIME_SHOW',
  CLINIC_BOOKING_CLOSED_TIME_UPDATE = 'CLINIC_BOOKING_CLOSED_TIME_UPDATE',
  CLINIC_BOOKING_CLOSED_TIME_CANCEL = 'CLINIC_BOOKING_CLOSED_TIME_CANCEL',
  CLINIC_BOOKING_TIME_SHOW = 'CLINIC_BOOKING_TIME_SHOW',
  CLINIC_BOOKING_TIME_GET_WITH_DOCTOR = 'CLINIC_BOOKING_TIME_GET_WITH_DOCTOR',
  CLINIC_BOOKING_TIME_UPDATE = 'CLINIC_BOOKING_TIME_UPDATE',
  CLINIC_BOOKING_TIME_SLOT_UPDATE = 'CLINIC_BOOKING_TIME_SLOT_UPDATE',
  CLINIC_BOOKING_TIME_SLOT_UPDATE_BY_TIME = 'CLINIC_BOOKING_TIME_SLOT_UPDATE_BY_TIME',
  CLINIC_BOOKING_TIME_SLOT_OPTION_FOR_BOOKING_FORM = 'CLINIC_BOOKING_TIME_SLOT_OPTION_FOR_BOOKING_FORM',
  CLINIC_BOOKING_TIME_SLOT_OPTION_FOR_DIAGNOSTIC_ANCILLARY_FORM = 'CLINIC_BOOKING_TIME_SLOT_OPTION_FOR_DIAGNOSTIC_ANCILLARY_FORM',
  CLINIC_BOOKING_TIME_SLOT_OPTION_DATES_FOR_BOOKING_FORM = 'CLINIC_BOOKING_TIME_SLOT_OPTION_DATES_FOR_BOOKING_FORM',
  CLINIC_BOOKING_TIME_SLOT_OPTION_DATES_FOR_DIAGNOSTIC_ANCILLARY_FORM = 'CLINIC_BOOKING_TIME_SLOT_OPTION_DATES_FOR_DIAGNOSTIC_ANCILLARY_FORM',
  CLINIC_MANDIRI_EDC_CREATE = 'CLINIC_MANDIRI_EDC_CREATE',
  CLINIC_MANDIRI_EDC_LIST = 'CLINIC_MANDIRI_EDC_LIST',
  CLINIC_MANDIRI_EDC_SHOW = 'CLINIC_MANDIRI_EDC_SHOW',
  CLINIC_MANDIRI_EDC_UPDATE = 'CLINIC_MANDIRI_EDC_UPDATE',
  CLINIC_MANDIRI_EDC_DELETE = 'CLINIC_MANDIRI_EDC_DELETE',
  CLINIC_MANDIRI_EDC_OPTION_FOR_CASHIER_FORM = 'CLINIC_MANDIRI_EDC_OPTION_FOR_CASHIER_FORM',
  CLINIC_OTTOPAY_EDC_CREATE = 'CLINIC_OTTOPAY_EDC_CREATE',
  CLINIC_OTTOPAY_EDC_LIST = 'CLINIC_OTTOPAY_EDC_LIST',
  CLINIC_OTTOPAY_EDC_SHOW = 'CLINIC_OTTOPAY_EDC_SHOW',
  CLINIC_OTTOPAY_EDC_UPDATE = 'CLINIC_OTTOPAY_EDC_UPDATE',
  CLINIC_OTTOPAY_EDC_DELETE = 'CLINIC_OTTOPAY_EDC_DELETE',
  CLINIC_OTTOPAY_EDC_OPTION_FOR_CASHIER_FORM = 'CLINIC_OTTOPAY_EDC_OPTION_FOR_CASHIER_FORM',
  CLINIC_PRINTER_CREATE = 'CLINIC_PRINTER_CREATE',
  CLINIC_PRINTER_DELETE = 'CLINIC_PRINTER_DELETE',
  CLINIC_PRINTER_OPTION_FOR_CASHIER_FORM = 'CLINIC_PRINTER_OPTION_FOR_CASHIER_FORM',
  CLINIC_PRINTER_OPTION_FOR_QUEUE_COUNTER = 'CLINIC_PRINTER_OPTION_FOR_QUEUE_COUNTER',
  CLINIC_PRINTER_OPTION_FOR_PRINT_MEDICINAL_LABEL = 'CLINIC_PRINTER_OPTION_FOR_PRINT_MEDICINAL_LABEL',
  CLINIC_PRINTER_OPTION_FOR_PRINT_PATIENT_VISIT_LABEL = 'CLINIC_PRINTER_OPTION_FOR_PRINT_PATIENT_VISIT_LABEL',
  CLINIC_PRINTER_GATEWAY_CREATE = 'CLINIC_PRINTER_GATEWAY_CREATE',
  CLINIC_PRINTER_GATEWAY_LIST = 'CLINIC_PRINTER_GATEWAY_LIST',
  CLINIC_PRINTER_GATEWAY_SHOW = 'CLINIC_PRINTER_GATEWAY_SHOW',
  CLINIC_PRINTER_GATEWAY_UPDATE = 'CLINIC_PRINTER_GATEWAY_UPDATE',
  CLINIC_PRINTER_GATEWAY_DELETE = 'CLINIC_PRINTER_GATEWAY_DELETE',
  CLINIC_SETTING_LIST = 'CLINIC_SETTING_LIST',
  CLINIC_SETTING_UPDATE = 'CLINIC_SETTING_UPDATE',
  DIAGNOSTIC_ANCILLARY_CREATE = 'DIAGNOSTIC_ANCILLARY_CREATE',
  DIAGNOSTIC_ANCILLARY_LIST = 'DIAGNOSTIC_ANCILLARY_LIST',
  DIAGNOSTIC_ANCILLARY_LIST_ACTION = 'DIAGNOSTIC_ANCILLARY_LIST_ACTION',
  DIAGNOSTIC_ANCILLARY_LIST_SUMMARY = 'DIAGNOSTIC_ANCILLARY_LIST_SUMMARY',
  DIAGNOSTIC_ANCILLARY_SHOW = 'DIAGNOSTIC_ANCILLARY_SHOW',
  DIAGNOSTIC_ANCILLARY_SHOW_ACTION = 'DIAGNOSTIC_ANCILLARY_SHOW_ACTION',
  DIAGNOSTIC_ANCILLARY_SHOW_SUMMARY = 'DIAGNOSTIC_ANCILLARY_SHOW_SUMMARY',
  DIAGNOSTIC_ANCILLARY_UPDATE = 'DIAGNOSTIC_ANCILLARY_UPDATE',
  DIAGNOSTIC_ANCILLARY_CANCEL = 'DIAGNOSTIC_ANCILLARY_CANCEL',
  DIAGNOSTIC_ANCILLARY_GENERATE_REPORT = 'DIAGNOSTIC_ANCILLARY_GENERATE_REPORT',
  DIAGNOSTIC_ANCILLARY_DOWNLOAD = 'DIAGNOSTIC_ANCILLARY_DOWNLOAD',
  DIAGNOSTIC_ANCILLARY_UPDATE_SUMMARY = 'DIAGNOSTIC_ANCILLARY_UPDATE_SUMMARY',
  DIAGNOSTIC_ANCILLARY_UPDATE_DIAGNOSES = 'DIAGNOSTIC_ANCILLARY_UPDATE_DIAGNOSES',
  DIAGNOSTIC_ANCILLARY_UPDATE_EXAMINATIONS = 'DIAGNOSTIC_ANCILLARY_UPDATE_EXAMINATIONS',
  DIAGNOSTIC_ANCILLARY_START = 'DIAGNOSTIC_ANCILLARY_START',
  DIAGNOSTIC_ANCILLARY_SUBMIT_RESULT = 'DIAGNOSTIC_ANCILLARY_SUBMIT_RESULT',
  DIAGNOSTIC_ANCILLARY_SUBMIT_SUMMARY = 'DIAGNOSTIC_ANCILLARY_SUBMIT_SUMMARY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_APPROVE_RESULT = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_APPROVE_RESULT',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_REJECT_RESULT = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_REJECT_RESULT',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_UPDATE_EVALUATION = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_UPDATE_EVALUATION',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_SUBMIT_EVALUATION = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_SUBMIT_EVALUATION',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_APPROVE_EVALUATION = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_APPROVE_EVALUATION',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_REJECT_EVALUATION = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_REJECT_EVALUATION',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_DOWNLOAD = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_DOWNLOAD',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_XRAY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_LABORATORY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_LABORATORY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_ECHO = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_ECHO',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_EKG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_EKG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_TREADMILL = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_TREADMILL',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_USG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_USG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_DENTAL_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_UPLOAD_FOR_DENTAL_XRAY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_DENTAL_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_DENTAL_XRAY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_ECHO = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_ECHO',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_EKG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_EKG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_LABORATORY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_LABORATORY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_ODONTOGRAM = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_ODONTOGRAM',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_TREADMILL = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_TREADMILL',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_USG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_USG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_LIST_FOR_XRAY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DOWNLOAD = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DOWNLOAD',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_DENTAL_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_DENTAL_XRAY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_ECHO = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_ECHO',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_EKG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_EKG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_LABORATORY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_LABORATORY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_TREADMILL = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_TREADMILL',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_USG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_USG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_MOVE_FOR_XRAY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_DENTAL_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_DENTAL_XRAY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_ECHO = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_ECHO',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_EKG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_EKG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_LABORATORY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_LABORATORY',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_TREADMILL = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_TREADMILL',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_USG = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_USG',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_XRAY = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_FILE_DELETE_FOR_XRAY',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_CREATE = 'DIAGNOSTIC_ANCILLARY_ODONTOGRAM_CREATE',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_LIST = 'DIAGNOSTIC_ANCILLARY_ODONTOGRAM_LIST',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_RENDER = 'DIAGNOSTIC_ANCILLARY_ODONTOGRAM_RENDER',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_UPDATE = 'DIAGNOSTIC_ANCILLARY_ODONTOGRAM_UPDATE',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_SUBMIT = 'DIAGNOSTIC_ANCILLARY_ODONTOGRAM_SUBMIT',
  DIAGNOSTIC_ANCILLARY_ODONTOGRAM_DELETE = 'DIAGNOSTIC_ANCILLARY_ODONTOGRAM_DELETE',
  DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_SHOW = 'DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_SHOW',
  DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_SUBMIT = 'DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_SUBMIT',
  DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_TEMP_SHOW = 'DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_TEMP_SHOW',
  DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_TEMP_UPDATE = 'DIAGNOSTIC_ANCILLARY_PHYSICAL_EXAMINATION_TEMP_UPDATE',
  DIAGNOSTIC_ANCILLARY_EXAMINATION_XRAY_LIST = 'DIAGNOSTIC_ANCILLARY_EXAMINATION_XRAY_LIST',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_CREATE = 'DIAGNOSTIC_ANCILLARY_TEMPLATE_CREATE',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_LIST = 'DIAGNOSTIC_ANCILLARY_TEMPLATE_LIST',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_SHOW = 'DIAGNOSTIC_ANCILLARY_TEMPLATE_SHOW',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_UPDATE = 'DIAGNOSTIC_ANCILLARY_TEMPLATE_UPDATE',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_DELETE = 'DIAGNOSTIC_ANCILLARY_TEMPLATE_DELETE',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_OPTION = 'DIAGNOSTIC_ANCILLARY_TEMPLATE_OPTION',
  DIAGNOSTIC_ANCILLARY_TEMPLATE_TYPE_OPTION = 'DIAGNOSTIC_ANCILLARY_TEMPLATE_TYPE_OPTION',
  DOCTOR_LIST = 'DOCTOR_LIST',
  DOCTOR_SHOW = 'DOCTOR_SHOW',
  DOCTOR_OPTION_FOR_APPOINTMENT_FORM = 'DOCTOR_OPTION_FOR_APPOINTMENT_FORM',
  DOCTOR_OPTION_FOR_TELECONSULT_FORM = 'DOCTOR_OPTION_FOR_TELECONSULT_FORM',
  DOCTOR_OPTION_FOR_BOOKING_FORM_WITH_TIME_SLOT = 'DOCTOR_OPTION_FOR_BOOKING_FORM_WITH_TIME_SLOT',
  DOCTOR_OPTION_FOR_BOOKING_FORM_WITH_CLINIC = 'DOCTOR_OPTION_FOR_BOOKING_FORM_WITH_CLINIC',
  DOCTOR_OPTION_FOR_BOOKING_FORM_REPLACE_DOCTOR = 'DOCTOR_OPTION_FOR_BOOKING_FORM_REPLACE_DOCTOR',
  DOCTOR_BOOKING_TIME_SLOT_GET_WITH_DOCTOR_TIME_SLOT = 'DOCTOR_BOOKING_TIME_SLOT_GET_WITH_DOCTOR_TIME_SLOT',
  DOCTOR_BOOKING_TIME_SLOT_LIST_DOCTOR = 'DOCTOR_BOOKING_TIME_SLOT_LIST_DOCTOR',
  DOCTOR_BOOKING_TIME_SLOT_UPDATE_DOCTOR_TIME_SLOT = 'DOCTOR_BOOKING_TIME_SLOT_UPDATE_DOCTOR_TIME_SLOT',
  DOCTOR_BOOKING_TIME_OFF_CREATE = 'DOCTOR_BOOKING_TIME_OFF_CREATE',
  DOCTOR_BOOKING_TIME_OFF_LIST_DOCTOR = 'DOCTOR_BOOKING_TIME_OFF_LIST_DOCTOR',
  DOCTOR_BOOKING_TIME_OFF_LIST = 'DOCTOR_BOOKING_TIME_OFF_LIST',
  DOCTOR_BOOKING_TIME_OFF_SHOW = 'DOCTOR_BOOKING_TIME_OFF_SHOW',
  DOCTOR_BOOKING_TIME_OFF_UPDATE = 'DOCTOR_BOOKING_TIME_OFF_UPDATE',
  DOCTOR_BOOKING_TIME_OFF_CANCEL = 'DOCTOR_BOOKING_TIME_OFF_CANCEL',
  DOCTOR_MEMO_CREATE = 'DOCTOR_MEMO_CREATE',
  DOCTOR_MEMO_UPDATE = 'DOCTOR_MEMO_UPDATE',
  DOCTOR_REFERRAL_CREATE = 'DOCTOR_REFERRAL_CREATE',
  DOCTOR_REFERRAL_UPDATE = 'DOCTOR_REFERRAL_UPDATE',
  FILE_TOKEN_CREATE_FOR_DIAGNOSTIC_ANCILLARY_DICOM = 'FILE_TOKEN_CREATE_FOR_DIAGNOSTIC_ANCILLARY_DICOM',
  HEALTH_EXAMINATION_RESULT_CREATE = 'HEALTH_EXAMINATION_RESULT_CREATE',
  HEALTH_EXAMINATION_RESULT_UPDATE = 'HEALTH_EXAMINATION_RESULT_UPDATE',
  MEDICAL_SUMMARY_CREATE = 'MEDICAL_SUMMARY_CREATE',
  EXAMINATION_LIST = 'EXAMINATION_LIST',
  EXAMINATION_SHOW = 'EXAMINATION_SHOW',
  EXAMINATION_OPTION_FOR_MEDICAL_RECORD = 'EXAMINATION_OPTION_FOR_MEDICAL_RECORD',
  ICD_10_LIST = 'ICD_10_LIST',
  ICD_10_TREE = 'ICD_10_TREE',
  ICD_10_OPTION_FOR_PATIENT_DISEASE_HISTORY_FORM = 'ICD_10_OPTION_FOR_PATIENT_DISEASE_HISTORY_FORM',
  ICD_10_OPTION_FOR_PATIENT_CONGENITAL_DISEASE_FORM = 'ICD_10_OPTION_FOR_PATIENT_CONGENITAL_DISEASE_FORM',
  ICD_10_TRENDING_LIST = 'ICD_10_TRENDING_LIST',
  INJECTION_SHOW = 'INJECTION_SHOW',
  INSURANCE_OPTION_FOR_QUEUE_NUMBER = 'INSURANCE_OPTION_FOR_QUEUE_NUMBER',
  INSURANCE_PAYOR_OPTION_FOR_QUEUE_NUMBER = 'INSURANCE_PAYOR_OPTION_FOR_QUEUE_NUMBER',
  CART_SHOW = 'CART_SHOW',
  CART_ITEM_CREATE_FOR_ACTIVE_RETAIL_CART = 'CART_ITEM_CREATE_FOR_ACTIVE_RETAIL_CART',
  CART_ITEM_CREATE_FOR_ACTIVE_RETAIL_CART_BY_BARCODE_OR_CODE = 'CART_ITEM_CREATE_FOR_ACTIVE_RETAIL_CART_BY_BARCODE_OR_CODE',
  CART_ITEM_QTY_UPDATE_IN_ACTIVE_CART = 'CART_ITEM_QTY_UPDATE_IN_ACTIVE_CART',
  CART_ITEM_REPRINT_DOCUMENT_FEE_DELETE = 'CART_ITEM_REPRINT_DOCUMENT_FEE_DELETE',
  CART_ITEM_DELETE_FROM_ACTIVE_RETAIL_CART = 'CART_ITEM_DELETE_FROM_ACTIVE_RETAIL_CART',
  MEDICAL_CERTIFICATE_CREATE = 'MEDICAL_CERTIFICATE_CREATE',
  MEDICAL_CERTIFICATE_UPDATE = 'MEDICAL_CERTIFICATE_UPDATE',
  MEDICAL_CERTIFICATE_DIAGNOSE_CREATE = 'MEDICAL_CERTIFICATE_DIAGNOSE_CREATE',
  MEDICAL_CERTIFICATE_DIAGNOSE_DELETE = 'MEDICAL_CERTIFICATE_DIAGNOSE_DELETE',
  MEDICAL_RECORD_BEGIN = 'MEDICAL_RECORD_BEGIN',
  MEDICAL_RECORD_LIST = 'MEDICAL_RECORD_LIST',
  MEDICAL_RECORD_LIST_FOR_STAND_BY_FORM = 'MEDICAL_RECORD_LIST_FOR_STAND_BY_FORM',
  MEDICAL_RECORD_SHOW = 'MEDICAL_RECORD_SHOW',
  MEDICAL_RECORD_UPDATE = 'MEDICAL_RECORD_UPDATE',
  MEDICAL_RECORD_UPDATE_APPLY_TEMPLATE = 'MEDICAL_RECORD_UPDATE_APPLY_TEMPLATE',
  MEDICAL_RECORD_UPDATE_ANNOTATION = 'MEDICAL_RECORD_UPDATE_ANNOTATION',
  MEDICAL_RECORD_UPDATE_AMENDMENT = 'MEDICAL_RECORD_UPDATE_AMENDMENT',
  MEDICAL_RECORD_UPDATE_DOCTOR_RATE_TYPE = 'MEDICAL_RECORD_UPDATE_DOCTOR_RATE_TYPE',
  MEDICAL_RECORD_STAND_BY = 'MEDICAL_RECORD_STAND_BY',
  MEDICAL_RECORD_RESUME = 'MEDICAL_RECORD_RESUME',
  MEDICAL_RECORD_END = 'MEDICAL_RECORD_END',
  MEDICAL_RECORD_AMENDMENT_HISTORY_LIST = 'MEDICAL_RECORD_AMENDMENT_HISTORY_LIST',
  MEDICAL_RECORD_DIAGNOSE_CREATE = 'MEDICAL_RECORD_DIAGNOSE_CREATE',
  MEDICAL_RECORD_DIAGNOSE_UPDATE = 'MEDICAL_RECORD_DIAGNOSE_UPDATE',
  MEDICAL_RECORD_DIAGNOSE_DELETE = 'MEDICAL_RECORD_DIAGNOSE_DELETE',
  MEDICAL_RECORD_EXAMINATION_CREATE = 'MEDICAL_RECORD_EXAMINATION_CREATE',
  MEDICAL_RECORD_EXAMINATION_UPDATE = 'MEDICAL_RECORD_EXAMINATION_UPDATE',
  MEDICAL_RECORD_EXAMINATION_DELETE = 'MEDICAL_RECORD_EXAMINATION_DELETE',
  MEDICAL_RECORD_MEDICAL_TOOL_CREATE = 'MEDICAL_RECORD_MEDICAL_TOOL_CREATE',
  MEDICAL_RECORD_MEDICAL_TOOL_UPDATE = 'MEDICAL_RECORD_MEDICAL_TOOL_UPDATE',
  MEDICAL_RECORD_MEDICAL_TOOL_DELETE = 'MEDICAL_RECORD_MEDICAL_TOOL_DELETE',
  MEDICAL_RECORD_ODONTOGRAM_CREATE = 'MEDICAL_RECORD_ODONTOGRAM_CREATE',
  MEDICAL_RECORD_ODONTOGRAM_LIST = 'MEDICAL_RECORD_ODONTOGRAM_LIST',
  MEDICAL_RECORD_ODONTOGRAM_RENDER = 'MEDICAL_RECORD_ODONTOGRAM_RENDER',
  MEDICAL_RECORD_ODONTOGRAM_UPDATE = 'MEDICAL_RECORD_ODONTOGRAM_UPDATE',
  MEDICAL_RECORD_ODONTOGRAM_DELETE = 'MEDICAL_RECORD_ODONTOGRAM_DELETE',
  MEDICAL_RECORD_ODONTOGRAM_HISTORY_LIST = 'MEDICAL_RECORD_ODONTOGRAM_HISTORY_LIST',
  MEDICAL_RECORD_PRESCRIPTION_CREATE = 'MEDICAL_RECORD_PRESCRIPTION_CREATE',
  MEDICAL_RECORD_PRESCRIPTION_UPDATE = 'MEDICAL_RECORD_PRESCRIPTION_UPDATE',
  MEDICAL_RECORD_PRESCRIPTION_DELETE = 'MEDICAL_RECORD_PRESCRIPTION_DELETE',
  MEDICAL_RECORD_TREATMENT_CREATE = 'MEDICAL_RECORD_TREATMENT_CREATE',
  MEDICAL_RECORD_TREATMENT_UPDATE = 'MEDICAL_RECORD_TREATMENT_UPDATE',
  MEDICAL_RECORD_TREATMENT_DELETE = 'MEDICAL_RECORD_TREATMENT_DELETE',
  MEDICAL_RECORD_PRODUCT_BUNDLING_CREATE = 'MEDICAL_RECORD_PRODUCT_BUNDLING_CREATE',
  MEDICAL_RECORD_PRODUCT_BUNDLING_UPDATE = 'MEDICAL_RECORD_PRODUCT_BUNDLING_UPDATE',
  MEDICAL_RECORD_PRODUCT_BUNDLING_DELETE = 'MEDICAL_RECORD_PRODUCT_BUNDLING_DELETE',
  MEDICAL_RECORD_TEMPLATE_CREATE = 'MEDICAL_RECORD_TEMPLATE_CREATE',
  MEDICAL_RECORD_TEMPLATE_LIST = 'MEDICAL_RECORD_TEMPLATE_LIST',
  MEDICAL_RECORD_TEMPLATE_SHOW = 'MEDICAL_RECORD_TEMPLATE_SHOW',
  MEDICAL_RECORD_TEMPLATE_UPDATE = 'MEDICAL_RECORD_TEMPLATE_UPDATE',
  MEDICAL_RECORD_TEMPLATE_DELETE = 'MEDICAL_RECORD_TEMPLATE_DELETE',
  MEDICAL_RECORD_TEMPLATE_OPTION_FOR_MEDICAL_RECORD_FORM = 'MEDICAL_RECORD_TEMPLATE_OPTION_FOR_MEDICAL_RECORD_FORM',
  MEDICAL_RECORD_TEMPLATE_DIAGNOSE_CREATE = 'MEDICAL_RECORD_TEMPLATE_DIAGNOSE_CREATE',
  MEDICAL_RECORD_TEMPLATE_DIAGNOSE_UPDATE = 'MEDICAL_RECORD_TEMPLATE_DIAGNOSE_UPDATE',
  MEDICAL_RECORD_TEMPLATE_DIAGNOSE_DELETE = 'MEDICAL_RECORD_TEMPLATE_DIAGNOSE_DELETE',
  MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_CREATE = 'MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_CREATE',
  MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_UPDATE = 'MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_UPDATE',
  MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_DELETE = 'MEDICAL_RECORD_TEMPLATE_MEDICAL_TOOL_DELETE',
  MEDICAL_RECORD_TEMPLATE_TREATMENT_CREATE = 'MEDICAL_RECORD_TEMPLATE_TREATMENT_CREATE',
  MEDICAL_RECORD_TEMPLATE_TREATMENT_UPDATE = 'MEDICAL_RECORD_TEMPLATE_TREATMENT_UPDATE',
  MEDICAL_RECORD_TEMPLATE_TREATMENT_DELETE = 'MEDICAL_RECORD_TEMPLATE_TREATMENT_DELETE',
  MEDICAL_RECORD_TEMPLATE_EXAMINATION_CREATE = 'MEDICAL_RECORD_TEMPLATE_EXAMINATION_CREATE',
  MEDICAL_RECORD_TEMPLATE_EXAMINATION_UPDATE = 'MEDICAL_RECORD_TEMPLATE_EXAMINATION_UPDATE',
  MEDICAL_RECORD_TEMPLATE_EXAMINATION_DELETE = 'MEDICAL_RECORD_TEMPLATE_EXAMINATION_DELETE',
  MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_CREATE = 'MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_CREATE',
  MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_UPDATE = 'MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_UPDATE',
  MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_DELETE = 'MEDICAL_RECORD_TEMPLATE_PRESCRIPTION_DELETE',
  MEDICAL_RECORD_WAIVE_UPDATE = 'MEDICAL_RECORD_WAIVE_UPDATE',
  MEDICAL_TOOL_OPTION_FOR_MEDICAL_RECORD = 'MEDICAL_TOOL_OPTION_FOR_MEDICAL_RECORD',
  MEDICINAL_DISPENSE_DOWNLOAD = 'MEDICINAL_DISPENSE_DOWNLOAD',
  MEDICINAL_DISPENSE_CREATE = 'MEDICINAL_DISPENSE_CREATE',
  MEDICINAL_DISPENSE_UPDATE = 'MEDICINAL_DISPENSE_UPDATE',
  MEDICINAL_DISPENSE_UPLOAD = 'MEDICINAL_DISPENSE_UPLOAD',
  MEDICINAL_DISPENSE_LIST = 'MEDICINAL_DISPENSE_LIST',
  MEDICINAL_DISPENSE_SHOW = 'MEDICINAL_DISPENSE_SHOW',
  MEDICINAL_DISPENSE_ADD_MIXED_MEDICINE_FEE = 'MEDICINAL_DISPENSE_ADD_MIXED_MEDICINE_FEE',
  MEDICINAL_DISPENSE_REMOVE_MIXED_MEDICINE_FEE = 'MEDICINAL_DISPENSE_REMOVE_MIXED_MEDICINE_FEE',
  MEDICINAL_DISPENSE_PRINT_BLANK = 'MEDICINAL_DISPENSE_PRINT_BLANK',
  MEDICINAL_DISPENSE_CALIBRATE = 'MEDICINAL_DISPENSE_CALIBRATE',
  MEDICINAL_DISPENSE_UPDATE_CHECKED = 'MEDICINAL_DISPENSE_UPDATE_CHECKED',
  MEDICINAL_DISPENSE_UPDATE_COMPLETED = 'MEDICINAL_DISPENSE_UPDATE_COMPLETED',
  MEDICINAL_DISPENSE_ITEM_PRINT = 'MEDICINAL_DISPENSE_ITEM_PRINT',
  MEDICINAL_DISPENSE_ITEM_CREATE_EXPIRED_DATE = 'MEDICINAL_DISPENSE_ITEM_CREATE_EXPIRED_DATE',
  MEDICINAL_DISPENSE_ITEM_UPDATE_EXPIRED_DATE = 'MEDICINAL_DISPENSE_ITEM_UPDATE_EXPIRED_DATE',
  MEDICINAL_DISPENSE_ITEM_DELETE_EXPIRED_DATE = 'MEDICINAL_DISPENSE_ITEM_DELETE_EXPIRED_DATE',
  MEDICINAL_DISPENSE_ITEM_UPDATE = 'MEDICINAL_DISPENSE_ITEM_UPDATE',
  MEDICINAL_DISPENSE_PRESCRIPTION_CREATE = 'MEDICINAL_DISPENSE_PRESCRIPTION_CREATE',
  MEDICINAL_DISPENSE_PRESCRIPTION_UPDATE = 'MEDICINAL_DISPENSE_PRESCRIPTION_UPDATE',
  MEDICINAL_DISPENSE_PRESCRIPTION_DELETE = 'MEDICINAL_DISPENSE_PRESCRIPTION_DELETE',
  MEDICINE_SHOW = 'MEDICINE_SHOW',
  MEDICINE_OPTION_FOR_MEDICINE_ALLERGY_FORM = 'MEDICINE_OPTION_FOR_MEDICINE_ALLERGY_FORM',
  MEDICINE_OPTION_FOR_MEDICINE_HISTORY_FORM = 'MEDICINE_OPTION_FOR_MEDICINE_HISTORY_FORM',
  MEMBER_CREATE = 'MEMBER_CREATE',
  MEMBER_OPTION = 'MEMBER_OPTION',
  NET_PROMOTER_SCORE_START_BY_QUEUE_NUMBER = 'NET_PROMOTER_SCORE_START_BY_QUEUE_NUMBER',
  NET_PROMOTER_SCORE_START_BY_SALES_INVOICE = 'NET_PROMOTER_SCORE_START_BY_SALES_INVOICE',
  NET_PROMOTER_SCORE_GET_ACTIVE = 'NET_PROMOTER_SCORE_GET_ACTIVE',
  NET_PROMOTER_SCORE_END = 'NET_PROMOTER_SCORE_END',
  NET_PROMOTER_SCORE_ITEM_UPDATE = 'NET_PROMOTER_SCORE_ITEM_UPDATE',
  NRIC_CARD_OCR_EXTRACT = 'NRIC_CARD_OCR_EXTRACT',
  NRIC_CARD_OCR_UPLOAD = 'NRIC_CARD_OCR_UPLOAD',
  NURSE_LIST = 'NURSE_LIST',
  NURSE_SHOW = 'NURSE_SHOW',
  PATIENT_CREATE = 'PATIENT_CREATE',
  PATIENT_SHOW = 'PATIENT_SHOW',
  PATIENT_SHOW_MEDICAL_SUMMARY = 'PATIENT_SHOW_MEDICAL_SUMMARY',
  PATIENT_SHOW_MEDICAL_NOTES = 'PATIENT_SHOW_MEDICAL_NOTES',
  PATIENT_UPDATE = 'PATIENT_UPDATE',
  PATIENT_UPDATE_MEDICAL_SUMMARY = 'PATIENT_UPDATE_MEDICAL_SUMMARY',
  PATIENT_UPDATE_MEDICAL_NOTES = 'PATIENT_UPDATE_MEDICAL_NOTES',
  PATIENT_OPTION = 'PATIENT_OPTION',
  PATIENT_OPTION_FOR_APPOINTMENT_FORM = 'PATIENT_OPTION_FOR_APPOINTMENT_FORM',
  PATIENT_OPTION_FOR_PATIENT_DOCTOR_FORM = 'PATIENT_OPTION_FOR_PATIENT_DOCTOR_FORM',
  PATIENT_OPTION_FOR_PATIENT_RELATIVE_FORM = 'PATIENT_OPTION_FOR_PATIENT_RELATIVE_FORM',
  PATIENT_OPTION_FOR_PATIENT_VISIT_FILTER = 'PATIENT_OPTION_FOR_PATIENT_VISIT_FILTER',
  PATIENT_OPTION_FOR_PATIENT_VISIT_FORM = 'PATIENT_OPTION_FOR_PATIENT_VISIT_FORM',
  PATIENT_OPTION_FOR_PATIENT_VITAL_CHECK_FILTER = 'PATIENT_OPTION_FOR_PATIENT_VITAL_CHECK_FILTER',
  PATIENT_OPTION_FOR_PATIENT_VITAL_CHECK_FORM = 'PATIENT_OPTION_FOR_PATIENT_VITAL_CHECK_FORM',
  PATIENT_OPTION_FOR_QUEUE_NUMBER_GENERATE_FORM = 'PATIENT_OPTION_FOR_QUEUE_NUMBER_GENERATE_FORM',
  PATIENT_OPTION_FOR_TASK_FORM = 'PATIENT_OPTION_FOR_TASK_FORM',
  PATIENT_OPTION_FOR_TELECONSULT = 'PATIENT_OPTION_FOR_TELECONSULT',
  PATIENT_OPTION_FOR_VACCINATION = 'PATIENT_OPTION_FOR_VACCINATION',
  PATIENT_OPTION_FOR_BOOKING_FORM = 'PATIENT_OPTION_FOR_BOOKING_FORM',
  PATIENT_OPTION_FOR_DIAGNOSTIC_ANCILLARY_FORM = 'PATIENT_OPTION_FOR_DIAGNOSTIC_ANCILLARY_FORM',
  PATIENT_ALLERGY_CREATE = 'PATIENT_ALLERGY_CREATE',
  PATIENT_ALLERGY_LIST = 'PATIENT_ALLERGY_LIST',
  PATIENT_ALLERGY_SHOW = 'PATIENT_ALLERGY_SHOW',
  PATIENT_ALLERGY_UPDATE = 'PATIENT_ALLERGY_UPDATE',
  PATIENT_ALLERGY_DELETE = 'PATIENT_ALLERGY_DELETE',
  PATIENT_CONGENITAL_DISEASE_CREATE = 'PATIENT_CONGENITAL_DISEASE_CREATE',
  PATIENT_CONGENITAL_DISEASE_LIST = 'PATIENT_CONGENITAL_DISEASE_LIST',
  PATIENT_CONGENITAL_DISEASE_SHOW = 'PATIENT_CONGENITAL_DISEASE_SHOW',
  PATIENT_CONGENITAL_DISEASE_UPDATE = 'PATIENT_CONGENITAL_DISEASE_UPDATE',
  PATIENT_CONGENITAL_DISEASE_DELETE = 'PATIENT_CONGENITAL_DISEASE_DELETE',
  PATIENT_DISEASE_HISTORY_CREATE = 'PATIENT_DISEASE_HISTORY_CREATE',
  PATIENT_DISEASE_HISTORY_LIST = 'PATIENT_DISEASE_HISTORY_LIST',
  PATIENT_DISEASE_HISTORY_SHOW = 'PATIENT_DISEASE_HISTORY_SHOW',
  PATIENT_DISEASE_HISTORY_UPDATE = 'PATIENT_DISEASE_HISTORY_UPDATE',
  PATIENT_DISEASE_HISTORY_DELETE = 'PATIENT_DISEASE_HISTORY_DELETE',
  PATIENT_DOCTOR_CREATE = 'PATIENT_DOCTOR_CREATE',
  PATIENT_DOCTOR_DELETE = 'PATIENT_DOCTOR_DELETE',
  PATIENT_DOCUMENT_LIST = 'PATIENT_DOCUMENT_LIST',
  PATIENT_DOCUMENT_UPLOAD = 'PATIENT_DOCUMENT_UPLOAD',
  PATIENT_DOCUMENT_COMPLETE = 'PATIENT_DOCUMENT_COMPLETE',
  PATIENT_DOCUMENT_DOWNLOAD = 'PATIENT_DOCUMENT_DOWNLOAD',
  PATIENT_DOCUMENT_DELETE = 'PATIENT_DOCUMENT_DELETE',
  PATIENT_INTERVIEW_CREATE = 'PATIENT_INTERVIEW_CREATE',
  PATIENT_INTERVIEW_LIST = 'PATIENT_INTERVIEW_LIST',
  PATIENT_INTERVIEW_SHOW = 'PATIENT_INTERVIEW_SHOW',
  PATIENT_INTERVIEW_UPDATE = 'PATIENT_INTERVIEW_UPDATE',
  PATIENT_INTERVIEW_DELETE = 'PATIENT_INTERVIEW_DELETE',
  PATIENT_MEDICINE_ALLERGY_CREATE = 'PATIENT_MEDICINE_ALLERGY_CREATE',
  PATIENT_MEDICINE_ALLERGY_LIST = 'PATIENT_MEDICINE_ALLERGY_LIST',
  PATIENT_MEDICINE_ALLERGY_SHOW = 'PATIENT_MEDICINE_ALLERGY_SHOW',
  PATIENT_MEDICINE_ALLERGY_UPDATE = 'PATIENT_MEDICINE_ALLERGY_UPDATE',
  PATIENT_MEDICINE_ALLERGY_DELETE = 'PATIENT_MEDICINE_ALLERGY_DELETE',
  PATIENT_MEDICINE_HISTORY_CREATE = 'PATIENT_MEDICINE_HISTORY_CREATE',
  PATIENT_MEDICINE_HISTORY_LIST = 'PATIENT_MEDICINE_HISTORY_LIST',
  PATIENT_MEDICINE_HISTORY_SHOW = 'PATIENT_MEDICINE_HISTORY_SHOW',
  PATIENT_MEDICINE_HISTORY_UPDATE = 'PATIENT_MEDICINE_HISTORY_UPDATE',
  PATIENT_MEDICINE_HISTORY_DELETE = 'PATIENT_MEDICINE_HISTORY_DELETE',
  PATIENT_RELATIVE_CREATE = 'PATIENT_RELATIVE_CREATE',
  PATIENT_RELATIVE_LIST = 'PATIENT_RELATIVE_LIST',
  PATIENT_RELATIVE_UPDATE = 'PATIENT_RELATIVE_UPDATE',
  PATIENT_RELATIVE_UPDATE_SET_DEFAULT = 'PATIENT_RELATIVE_UPDATE_SET_DEFAULT',
  PATIENT_RELATIVE_DELETE = 'PATIENT_RELATIVE_DELETE',
  PATIENT_RELATIVE_OPTION_FOR_QUEUE_NUMBER_FORM = 'PATIENT_RELATIVE_OPTION_FOR_QUEUE_NUMBER_FORM',
  PATIENT_SURGERY_CREATE = 'PATIENT_SURGERY_CREATE',
  PATIENT_SURGERY_LIST = 'PATIENT_SURGERY_LIST',
  PATIENT_SURGERY_SHOW = 'PATIENT_SURGERY_SHOW',
  PATIENT_SURGERY_UPDATE = 'PATIENT_SURGERY_UPDATE',
  PATIENT_SURGERY_DELETE = 'PATIENT_SURGERY_DELETE',
  PATIENT_TEST_RESULT_CREATE = 'PATIENT_TEST_RESULT_CREATE',
  PATIENT_TEST_RESULT_UPLOAD = 'PATIENT_TEST_RESULT_UPLOAD',
  PATIENT_TEST_RESULT_LIST = 'PATIENT_TEST_RESULT_LIST',
  PATIENT_TEST_RESULT_SHOW = 'PATIENT_TEST_RESULT_SHOW',
  PATIENT_TEST_RESULT_DOWNLOAD = 'PATIENT_TEST_RESULT_DOWNLOAD',
  PATIENT_TEST_RESULT_UPDATE = 'PATIENT_TEST_RESULT_UPDATE',
  PATIENT_TEST_RESULT_UPDATE_READ_STATUS = 'PATIENT_TEST_RESULT_UPDATE_READ_STATUS',
  PATIENT_VISIT_LIST = 'PATIENT_VISIT_LIST',
  PATIENT_VISIT_SUMMARIZE_HISTORY = 'PATIENT_VISIT_SUMMARIZE_HISTORY',
  PATIENT_VISIT_SHOW = 'PATIENT_VISIT_SHOW',
  PATIENT_VISIT_PRINT_LABEL = 'PATIENT_VISIT_PRINT_LABEL',
  PATIENT_VISIT_PRINT_LABEL_PREVIEW = 'PATIENT_VISIT_PRINT_LABEL_PREVIEW',
  PATIENT_VISIT_INSURANCE_CARD_FILE_SHOW_FOR_QUEUE_NUMBER = 'PATIENT_VISIT_INSURANCE_CARD_FILE_SHOW_FOR_QUEUE_NUMBER',
  PATIENT_VISIT_INSURANCE_CARD_FILE_SHOW_FOR_MEDICAL_RECORD = 'PATIENT_VISIT_INSURANCE_CARD_FILE_SHOW_FOR_MEDICAL_RECORD',
  PATIENT_VISIT_UPDATE = 'PATIENT_VISIT_UPDATE',
  PATIENT_VISIT_OPTION_FOR_MEDICAL_RECORD = 'PATIENT_VISIT_OPTION_FOR_MEDICAL_RECORD',
  PATIENT_VITAL_CHECK_LIST = 'PATIENT_VITAL_CHECK_LIST',
  PATIENT_VITAL_CHECK_LIST_FOR_MEDICAL_RECORD = 'PATIENT_VITAL_CHECK_LIST_FOR_MEDICAL_RECORD',
  PATIENT_VITAL_CHECK_SHOW = 'PATIENT_VITAL_CHECK_SHOW',
  PATIENT_VITAL_CHECK_SHOW_LATEST = 'PATIENT_VITAL_CHECK_SHOW_LATEST',
  PATIENT_VITAL_CHECK_VISUALIZE = 'PATIENT_VITAL_CHECK_VISUALIZE',
  PATIENT_VITAL_CHECK_UPDATE_IS_NURSING = 'PATIENT_VITAL_CHECK_UPDATE_IS_NURSING',
  PATIENT_VITAL_CHECK_UPDATE_IS_PREGNANT = 'PATIENT_VITAL_CHECK_UPDATE_IS_PREGNANT',
  PATIENT_VITAL_CHECK_UPDATE_IS_SMOKING = 'PATIENT_VITAL_CHECK_UPDATE_IS_SMOKING',
  PHARMACIST_LIST = 'PHARMACIST_LIST',
  PHARMACIST_SHOW = 'PHARMACIST_SHOW',
  PRODUCT_LIST_FOR_RETAIL_CART = 'PRODUCT_LIST_FOR_RETAIL_CART',
  PRODUCT_PRICE_TAG_DOWNLOAD = 'PRODUCT_PRICE_TAG_DOWNLOAD',
  PRODUCT_OPTION_FOR_MEDICAL_RECORD = 'PRODUCT_OPTION_FOR_MEDICAL_RECORD',
  PRODUCT_OPTION_FOR_MEDICINAL_DISPENSE_PRESCRIPTION = 'PRODUCT_OPTION_FOR_MEDICINAL_DISPENSE_PRESCRIPTION',
  PRODUCT_OPTION_FOR_PRICE_TAG_DOWNLOAD = 'PRODUCT_OPTION_FOR_PRICE_TAG_DOWNLOAD',
  PRODUCT_OPTION_FOR_PRODUCT_ADJUSTMENT_FORM = 'PRODUCT_OPTION_FOR_PRODUCT_ADJUSTMENT_FORM',
  PRODUCT_OPTION_FOR_PRODUCT_RECEIVE_ITEM = 'PRODUCT_OPTION_FOR_PRODUCT_RECEIVE_ITEM',
  PRODUCT_OPTION_FOR_PRODUCT_TRANSFER_ITEM_FORM = 'PRODUCT_OPTION_FOR_PRODUCT_TRANSFER_ITEM_FORM',
  PRODUCT_OPTION_FOR_PRODUCT_TRANSFER_CLINIC_ITEM_FORM = 'PRODUCT_OPTION_FOR_PRODUCT_TRANSFER_CLINIC_ITEM_FORM',
  PRODUCT_OPTION_EXPIRED_DATE = 'PRODUCT_OPTION_EXPIRED_DATE',
  PRODUCT_ADJUSTMENT_CREATE = 'PRODUCT_ADJUSTMENT_CREATE',
  PRODUCT_ADJUSTMENT_LIST = 'PRODUCT_ADJUSTMENT_LIST',
  PRODUCT_ADJUSTMENT_SHOW = 'PRODUCT_ADJUSTMENT_SHOW',
  PRODUCT_ADJUSTMENT_UPDATE = 'PRODUCT_ADJUSTMENT_UPDATE',
  PRODUCT_ADJUSTMENT_DELETE = 'PRODUCT_ADJUSTMENT_DELETE',
  PRODUCT_ADJUSTMENT_OPTION_BATCH_NUMBERS = 'PRODUCT_ADJUSTMENT_OPTION_BATCH_NUMBERS',
  PRODUCT_ADJUSTMENT_ITEM_CREATE = 'PRODUCT_ADJUSTMENT_ITEM_CREATE',
  PRODUCT_ADJUSTMENT_ITEM_DELETE = 'PRODUCT_ADJUSTMENT_ITEM_DELETE',
  PRODUCT_BUNDLING_LIST = 'PRODUCT_BUNDLING_LIST',
  PRODUCT_BUNDLING_SHOW = 'PRODUCT_BUNDLING_SHOW',
  PRODUCT_BUNDLING_OPTION_FOR_MEDICAL_RECORD = 'PRODUCT_BUNDLING_OPTION_FOR_MEDICAL_RECORD',
  PRODUCT_INVENTORY_LIST = 'PRODUCT_INVENTORY_LIST',
  PRODUCT_INVENTORY_SHOW = 'PRODUCT_INVENTORY_SHOW',
  PRODUCT_INVENTORY_LIST_ACTIVITY_LOG = 'PRODUCT_INVENTORY_LIST_ACTIVITY_LOG',
  PRODUCT_INVENTORY_LIST_ACTIVITY_LOG_SUMMARIZED = 'PRODUCT_INVENTORY_LIST_ACTIVITY_LOG_SUMMARIZED',
  PRODUCT_PROMOTION_LIST = 'PRODUCT_PROMOTION_LIST',
  PRODUCT_PROMOTION_SHOW = 'PRODUCT_PROMOTION_SHOW',
  PRODUCT_PROMOTION_OPTION_FOR_PRICE_TAG_DOWNLOAD = 'PRODUCT_PROMOTION_OPTION_FOR_PRICE_TAG_DOWNLOAD',
  PRODUCT_RECEIVE_CREATE = 'PRODUCT_RECEIVE_CREATE',
  PRODUCT_RECEIVE_LIST = 'PRODUCT_RECEIVE_LIST',
  PRODUCT_RECEIVE_SHOW = 'PRODUCT_RECEIVE_SHOW',
  PRODUCT_RECEIVE_UPDATE = 'PRODUCT_RECEIVE_UPDATE',
  PRODUCT_RECEIVE_UPDATE_DISCOUNT_AND_TAX_PERCENTAGE = 'PRODUCT_RECEIVE_UPDATE_DISCOUNT_AND_TAX_PERCENTAGE',
  PRODUCT_RECEIVE_DELETE = 'PRODUCT_RECEIVE_DELETE',
  PRODUCT_RECEIVE_OPTION_BATCH_NUMBERS = 'PRODUCT_RECEIVE_OPTION_BATCH_NUMBERS',
  PRODUCT_RECEIVE_ITEM_CREATE = 'PRODUCT_RECEIVE_ITEM_CREATE',
  PRODUCT_RECEIVE_ITEM_DELETE = 'PRODUCT_RECEIVE_ITEM_DELETE',
  PRODUCT_UNIT_OPTION = 'PRODUCT_UNIT_OPTION',
  PRODUCT_UNIT_OPTION_FOR_PRODUCT_ADJUSTMENT_ITEM_FORM = 'PRODUCT_UNIT_OPTION_FOR_PRODUCT_ADJUSTMENT_ITEM_FORM',
  PRODUCT_UNIT_OPTION_FOR_PRODUCT_TRANSFER_ITEM_FORM = 'PRODUCT_UNIT_OPTION_FOR_PRODUCT_TRANSFER_ITEM_FORM',
  PRODUCT_UNIT_OPTION_FOR_PRODUCT_TRANSFER_CLINIC_ITEM_FORM = 'PRODUCT_UNIT_OPTION_FOR_PRODUCT_TRANSFER_CLINIC_ITEM_FORM',
  PRODUCT_UNIT_OPTION_FOR_PRICE_TAG_DOWNLOAD = 'PRODUCT_UNIT_OPTION_FOR_PRICE_TAG_DOWNLOAD',
  PRODUCT_TRANSFER_CREATE = 'PRODUCT_TRANSFER_CREATE',
  PRODUCT_TRANSFER_LIST = 'PRODUCT_TRANSFER_LIST',
  PRODUCT_TRANSFER_SHOW = 'PRODUCT_TRANSFER_SHOW',
  PRODUCT_TRANSFER_UPDATE = 'PRODUCT_TRANSFER_UPDATE',
  PRODUCT_TRANSFER_DELETE = 'PRODUCT_TRANSFER_DELETE',
  PRODUCT_TRANSFER_CLINIC_CREATE = 'PRODUCT_TRANSFER_CLINIC_CREATE',
  PRODUCT_TRANSFER_CLINIC_OUTBOUND_LIST = 'PRODUCT_TRANSFER_CLINIC_OUTBOUND_LIST',
  PRODUCT_TRANSFER_CLINIC_OUTBOUND_SHOW = 'PRODUCT_TRANSFER_CLINIC_OUTBOUND_SHOW',
  PRODUCT_TRANSFER_CLINIC_INBOUND_LIST = 'PRODUCT_TRANSFER_CLINIC_INBOUND_LIST',
  PRODUCT_TRANSFER_CLINIC_INBOUND_SHOW = 'PRODUCT_TRANSFER_CLINIC_INBOUND_SHOW',
  PRODUCT_TRANSFER_CLINIC_UPDATE = 'PRODUCT_TRANSFER_CLINIC_UPDATE',
  PRODUCT_TRANSFER_CLINIC_TRANSFER = 'PRODUCT_TRANSFER_CLINIC_TRANSFER',
  PRODUCT_TRANSFER_CLINIC_RECEIVE = 'PRODUCT_TRANSFER_CLINIC_RECEIVE',
  PRODUCT_TRANSFER_CLINIC_DELETE = 'PRODUCT_TRANSFER_CLINIC_DELETE',
  PRODUCT_TRANSFER_CLINIC_OUTBOUND_OPTION_BATCH_NUMBERS = 'PRODUCT_TRANSFER_CLINIC_OUTBOUND_OPTION_BATCH_NUMBERS',
  PRODUCT_TRANSFER_CLINIC_INBOUND_OPTION_BATCH_NUMBERS = 'PRODUCT_TRANSFER_CLINIC_INBOUND_OPTION_BATCH_NUMBERS',
  PRODUCT_TRANSFER_CLINIC_ITEM_CREATE = 'PRODUCT_TRANSFER_CLINIC_ITEM_CREATE',
  PRODUCT_TRANSFER_CLINIC_ITEM_UPDATE_IS_APPROVED = 'PRODUCT_TRANSFER_CLINIC_ITEM_UPDATE_IS_APPROVED',
  PRODUCT_TRANSFER_CLINIC_ITEM_DELETE = 'PRODUCT_TRANSFER_CLINIC_ITEM_DELETE',
  PRODUCT_TRANSFER_ITEM_CREATE = 'PRODUCT_TRANSFER_ITEM_CREATE',
  PRODUCT_TRANSFER_ITEM_DELETE = 'PRODUCT_TRANSFER_ITEM_DELETE',
  QUEUE_CREATE = 'QUEUE_CREATE',
  QUEUE_LIST = 'QUEUE_LIST',
  QUEUE_SHOW = 'QUEUE_SHOW',
  QUEUE_SHOW_PROCESS = 'QUEUE_SHOW_PROCESS',
  QUEUE_UPDATE = 'QUEUE_UPDATE',
  QUEUE_DELETE = 'QUEUE_DELETE',
  QUEUE_OPTION = 'QUEUE_OPTION',
  QUEUE_OPTION_FOR_QUEUE_COUNTER_CHECK_IN_FORM = 'QUEUE_OPTION_FOR_QUEUE_COUNTER_CHECK_IN_FORM',
  QUEUE_OPTION_FOR_QUEUE_DISPLAY = 'QUEUE_OPTION_FOR_QUEUE_DISPLAY',
  QUEUE_COUNTER_CREATE = 'QUEUE_COUNTER_CREATE',
  QUEUE_COUNTER_UPDATE = 'QUEUE_COUNTER_UPDATE',
  QUEUE_COUNTER_CHECK_IN = 'QUEUE_COUNTER_CHECK_IN',
  QUEUE_COUNTER_CHECK_OUT = 'QUEUE_COUNTER_CHECK_OUT',
  QUEUE_COUNTER_OPTION_FOR_CHECK_IN_FORM = 'QUEUE_COUNTER_OPTION_FOR_CHECK_IN_FORM',
  QUEUE_COUNTER_OPTION_FOR_QUEUE_NUMBER_COMPLETE_FORM = 'QUEUE_COUNTER_OPTION_FOR_QUEUE_NUMBER_COMPLETE_FORM',
  QUEUE_COUNTER_OPTION_FOR_QUEUE_NUMBER_GENERATE_FORM = 'QUEUE_COUNTER_OPTION_FOR_QUEUE_NUMBER_GENERATE_FORM',
  QUEUE_DISPLAY_CREATE = 'QUEUE_DISPLAY_CREATE',
  QUEUE_DISPLAY_LIST = 'QUEUE_DISPLAY_LIST',
  QUEUE_DISPLAY_SHOW = 'QUEUE_DISPLAY_SHOW',
  QUEUE_DISPLAY_UPDATE = 'QUEUE_DISPLAY_UPDATE',
  QUEUE_DISPLAY_DELETE = 'QUEUE_DISPLAY_DELETE',
  QUEUE_DISPLAY_BANNER_CREATE = 'QUEUE_DISPLAY_BANNER_CREATE',
  QUEUE_DISPLAY_BANNER_UPLOAD = 'QUEUE_DISPLAY_BANNER_UPLOAD',
  QUEUE_DISPLAY_BANNER_MOVE = 'QUEUE_DISPLAY_BANNER_MOVE',
  QUEUE_DISPLAY_BANNER_DELETE = 'QUEUE_DISPLAY_BANNER_DELETE',
  QUEUE_DISPLAY_QUEUE_CREATE = 'QUEUE_DISPLAY_QUEUE_CREATE',
  QUEUE_DISPLAY_QUEUE_DELETE = 'QUEUE_DISPLAY_QUEUE_DELETE',
  QUEUE_DISPLAY_RUNNING_TEXT_CREATE = 'QUEUE_DISPLAY_RUNNING_TEXT_CREATE',
  QUEUE_DISPLAY_RUNNING_TEXT_MOVE = 'QUEUE_DISPLAY_RUNNING_TEXT_MOVE',
  QUEUE_DISPLAY_RUNNING_TEXT_DELETE = 'QUEUE_DISPLAY_RUNNING_TEXT_DELETE',
  QUEUE_NUMBER_GENERATE = 'QUEUE_NUMBER_GENERATE',
  QUEUE_NUMBER_UPLOAD_INSURANCE_CARD = 'QUEUE_NUMBER_UPLOAD_INSURANCE_CARD',
  QUEUE_NUMBER_GET = 'QUEUE_NUMBER_GET',
  QUEUE_NUMBER_CURRENT = 'QUEUE_NUMBER_CURRENT',
  QUEUE_NUMBER_REPRINT = 'QUEUE_NUMBER_REPRINT',
  QUEUE_NUMBER_UPDATE = 'QUEUE_NUMBER_UPDATE',
  QUEUE_NUMBER_CALL = 'QUEUE_NUMBER_CALL',
  QUEUE_NUMBER_CALL_REPEAT = 'QUEUE_NUMBER_CALL_REPEAT',
  QUEUE_NUMBER_PROCESS = 'QUEUE_NUMBER_PROCESS',
  QUEUE_NUMBER_COMPLETE = 'QUEUE_NUMBER_COMPLETE',
  QUEUE_NUMBER_MOVE = 'QUEUE_NUMBER_MOVE',
  QUEUE_NUMBER_SKIP = 'QUEUE_NUMBER_SKIP',
  QUEUE_NUMBER_STAND_BY = 'QUEUE_NUMBER_STAND_BY',
  QUEUE_SESSION_BEGIN = 'QUEUE_SESSION_BEGIN',
  QUEUE_SESSION_END = 'QUEUE_SESSION_END',
  QUEUE_SESSION_GET_ACTIVE = 'QUEUE_SESSION_GET_ACTIVE',
  QUEUE_SESSION_CHECK_FOR_ACTIVE_QUEUE_NUMBER = 'QUEUE_SESSION_CHECK_FOR_ACTIVE_QUEUE_NUMBER',
  REPORT_DAILY_TRANSACTION_LIST = 'REPORT_DAILY_TRANSACTION_LIST',
  REPORT_DAILY_TRANSACTION_DOWNLOAD = 'REPORT_DAILY_TRANSACTION_DOWNLOAD',
  REPORT_FINANCE_INVENTORY_CREATE = 'REPORT_FINANCE_INVENTORY_CREATE',
  REPORT_FINANCE_INVENTORY_LIST = 'REPORT_FINANCE_INVENTORY_LIST',
  REPORT_FINANCE_INVENTORY_DOWNLOAD = 'REPORT_FINANCE_INVENTORY_DOWNLOAD',
  REPORT_FINANCE_INVENTORY_OPTION_DATES_FOR_CREATE_FORM = 'REPORT_FINANCE_INVENTORY_OPTION_DATES_FOR_CREATE_FORM',
  REPORT_INVENTORY_STOCK_CREATE = 'REPORT_INVENTORY_STOCK_CREATE',
  REPORT_INVENTORY_STOCK_LIST = 'REPORT_INVENTORY_STOCK_LIST',
  REPORT_INVENTORY_STOCK_DOWNLOAD = 'REPORT_INVENTORY_STOCK_DOWNLOAD',
  REPORT_MONTHLY_REVENUE_LIST = 'REPORT_MONTHLY_REVENUE_LIST',
  REPORT_MONTHLY_REVENUE_DOWNLOAD = 'REPORT_MONTHLY_REVENUE_DOWNLOAD',
  REPORT_MONTH_TO_DATE_SALES_LIST = 'REPORT_MONTH_TO_DATE_SALES_LIST',
  REPORT_MONTH_TO_DATE_SALES_DOWNLOAD = 'REPORT_MONTH_TO_DATE_SALES_DOWNLOAD',
  REPORT_NET_PROMOTER_SCORE_CREATE = 'REPORT_NET_PROMOTER_SCORE_CREATE',
  REPORT_NET_PROMOTER_SCORE_LIST = 'REPORT_NET_PROMOTER_SCORE_LIST',
  REPORT_NET_PROMOTER_SCORE_DOWNLOAD = 'REPORT_NET_PROMOTER_SCORE_DOWNLOAD',
  REPORT_SALES_CREATE = 'REPORT_SALES_CREATE',
  REPORT_SALES_LIST = 'REPORT_SALES_LIST',
  REPORT_SALES_DOWNLOAD = 'REPORT_SALES_DOWNLOAD',
  REPORT_SERVICE_AND_PERFORMANCE_CREATE = 'REPORT_SERVICE_AND_PERFORMANCE_CREATE',
  REPORT_SERVICE_AND_PERFORMANCE_LIST = 'REPORT_SERVICE_AND_PERFORMANCE_LIST',
  REPORT_SERVICE_AND_PERFORMANCE_DOWNLOAD = 'REPORT_SERVICE_AND_PERFORMANCE_DOWNLOAD',
  REPORT_WAIVE_FEE_DOWNLOAD = 'REPORT_WAIVE_FEE_DOWNLOAD',
  RETAIL_CART_GET_ACTIVE = 'RETAIL_CART_GET_ACTIVE',
  RETAIL_CART_SHOW = 'RETAIL_CART_SHOW',
  RETAIL_CART_HOLD_ACTIVE = 'RETAIL_CART_HOLD_ACTIVE',
  RETAIL_CART_RESTORE = 'RETAIL_CART_RESTORE',
  RETAIL_CART_DELETE_ACTIVE = 'RETAIL_CART_DELETE_ACTIVE',
  RETAIL_CART_DELETE = 'RETAIL_CART_DELETE',
  RETAIL_CART_OPTION_FOR_RESTORE_OR_DELETE = 'RETAIL_CART_OPTION_FOR_RESTORE_OR_DELETE',
  ROLE_OPTION_FOR_QUEUE_FORM = 'ROLE_OPTION_FOR_QUEUE_FORM',
  ROLE_OPTION_FOR_USER_FILTER = 'ROLE_OPTION_FOR_USER_FILTER',
  SALES_DIGITAL_PLATFORM_OPTION_FOR_SALES_INVOICE_PAYMENT = 'SALES_DIGITAL_PLATFORM_OPTION_FOR_SALES_INVOICE_PAYMENT',
  SALES_INVOICE_GENERATE = 'SALES_INVOICE_GENERATE',
  SALES_INVOICE_DOWNLOAD = 'SALES_INVOICE_DOWNLOAD',
  SALES_INVOICE_VOID = 'SALES_INVOICE_VOID',
  SALES_INVOICE_UPDATE_MEMBER_ID = 'SALES_INVOICE_UPDATE_MEMBER_ID',
  SALES_INVOICE_CANCEL = 'SALES_INVOICE_CANCEL',
  SALES_INVOICE_APPLY_VOUCHER_CODE = 'SALES_INVOICE_APPLY_VOUCHER_CODE',
  SALES_INVOICE_REMOVE_VOUCHER_CODE = 'SALES_INVOICE_REMOVE_VOUCHER_CODE',
  SALES_INVOICE_CHECK_VOUCHER_CODE = 'SALES_INVOICE_CHECK_VOUCHER_CODE',
  SALES_PAYMENT_CREATE = 'SALES_PAYMENT_CREATE',
  SALES_PAYMENT_SHOW = 'SALES_PAYMENT_SHOW',
  SALES_PAYMENT_PRINT_RETAIL = 'SALES_PAYMENT_PRINT_RETAIL',
  SALES_PAYMENT_CANCEL = 'SALES_PAYMENT_CANCEL',
  SALES_PAYMENT_METHOD_OPTION = 'SALES_PAYMENT_METHOD_OPTION',
  SUPPLIER_OPTION_FOR_PRODUCT_RECEIVE_FORM = 'SUPPLIER_OPTION_FOR_PRODUCT_RECEIVE_FORM',
  TASK_CREATE = 'TASK_CREATE',
  TASK_LIST = 'TASK_LIST',
  TASK_SHOW = 'TASK_SHOW',
  TASK_UPDATE = 'TASK_UPDATE',
  TASK_UPDATE_PRIORITY = 'TASK_UPDATE_PRIORITY',
  TASK_UPDATE_STATUS = 'TASK_UPDATE_STATUS',
  TASK_DELETE = 'TASK_DELETE',
  TASK_ATTACHMENT_UPLOAD = 'TASK_ATTACHMENT_UPLOAD',
  TASK_ATTACHMENT_SHOW = 'TASK_ATTACHMENT_SHOW',
  TASK_ATTACHMENT_DOWNLOAD = 'TASK_ATTACHMENT_DOWNLOAD',
  TASK_ATTACHMENT_DELETE = 'TASK_ATTACHMENT_DELETE',
  TASK_COMMENT_CREATE = 'TASK_COMMENT_CREATE',
  TASK_COMMENT_LIST = 'TASK_COMMENT_LIST',
  TASK_COMMENT_UPDATE = 'TASK_COMMENT_UPDATE',
  TASK_COMMENT_DELETE = 'TASK_COMMENT_DELETE',
  TELECONSULT_CREATE = 'TELECONSULT_CREATE',
  TELECONSULT_LIST = 'TELECONSULT_LIST',
  TELECONSULT_SHOW = 'TELECONSULT_SHOW',
  TELECONSULT_UPDATE = 'TELECONSULT_UPDATE',
  TELECONSULT_CANCEL_CONSULT = 'TELECONSULT_CANCEL_CONSULT',
  TELECONSULT_TYPE_OPTION = 'TELECONSULT_TYPE_OPTION',
  TREATMENT_LIST = 'TREATMENT_LIST',
  TREATMENT_SHOW = 'TREATMENT_SHOW',
  TREATMENT_OPTION_FOR_MEDICAL_RECORD = 'TREATMENT_OPTION_FOR_MEDICAL_RECORD',
  USER_LIST = 'USER_LIST',
  USER_SHOW = 'USER_SHOW',
  USER_OPTION_FOR_TASK_FORM = 'USER_OPTION_FOR_TASK_FORM',
  USER_OPTION_FOR_VOID_SALES_INVOICE_FORM = 'USER_OPTION_FOR_VOID_SALES_INVOICE_FORM',
  USER_OPTION_FOR_START_CASHIER_SESSION_FORM = 'USER_OPTION_FOR_START_CASHIER_SESSION_FORM',
  VACCINATION_CREATE = 'VACCINATION_CREATE',
  VACCINATION_LIST = 'VACCINATION_LIST',
  VACCINATION_SHOW = 'VACCINATION_SHOW',
  VACCINATION_UPDATE = 'VACCINATION_UPDATE',
  VACCINATION_DELETE = 'VACCINATION_DELETE',
  VACCINE_OPTION_FOR_VACCINATION_FORM = 'VACCINE_OPTION_FOR_VACCINATION_FORM',
  VIRTUAL_THERAPEUTIC_MOIETY_OPTION_FOR_PATIENT_MEDICINE_ALLERGY = 'VIRTUAL_THERAPEUTIC_MOIETY_OPTION_FOR_PATIENT_MEDICINE_ALLERGY',
  VIRTUAL_THERAPEUTIC_MOIETY_OPTION_FOR_PATIENT_MEDICINE_HISTORY = 'VIRTUAL_THERAPEUTIC_MOIETY_OPTION_FOR_PATIENT_MEDICINE_HISTORY',
}
